const en = {
	translation: {
		TITLE: {
			HP: 'Hefth',
			LOGIN: 'Login',
			RESET_PASSWORD: 'Reset Password',
			REGISTER: 'Register',
			DASHBOARD: 'Dashboard',
			ACTIONS: 'Actions',
			COMPANY_DOCUMENTS: 'Company Documents',
			SHAREHOLDERS_REGISTRY: 'Shareholder Registry',
			PROFILE: 'Profile',
			USERS_MANAGEMENT: 'Users Management',
			COMPANY_INFORMATION: 'Company Information',
			WALLET: 'Wallet',
			NOT_AUTHORIZED: 'Not Authorized',
			NOT_FOUND: 'Not Found',
			ASSEMBLIES: 'Assemblies',
			CAP_TABLE: 'Cap Table',
			MORTGAGES: 'Mortgages',
			CREATE_MORTGAGE: 'Create Mortgage',
			MORTGAGE_DETAILS: 'Mortgage Details',
			PAYMENT_SUCCESS: 'Payment Success',
			PAYMENT_FAILED: 'Payment Failed',
			UNAUTHORIZED: 'Unauthorized',
			TRANSACTIONS_LOGS: 'Transactions Logs',
			PAYMENT_CHECK: 'Payment Check',
			VOTING: 'Voting',
		},
		PAGES: {
			DASHBOARD: 'Dashboard',
			COMPANY_DOCUMENTS: 'Company Documents',
			SHAREHOLDERS_REGISTRY: 'Shareholder Registry',
			PROFILE: 'Profile',
			ACTIONS: 'Actions',
			USERS_MANAGEMENT: 'Users Management',
			COMPANY_INFORMATION: 'Company Information',
			WALLET: 'Wallet',
			SHAREHOLDER_INFO: 'Shareholder Info',
			REGISTRY_TRANSACTIONS: 'Registry Transactions',
			HEIRS_TRANSFER: 'Heirs Transfer',
			SUSPEND: 'Suspend',
			NOTICE: 'Notice',
			ANNOUNCEMENT: 'Announcement',
			UPDATE_DOCUMENTS: 'Update Documents',
			FINANCIAL_STATEMENT: 'Financial Statement',
			OVERVIEW: 'Overview',
			SHAREHOLDERS_LIST: 'Shareholders List',
			MAJOR_SHAREHOLDERS: 'Major Shareholders',
			TRANSACTIONS_LOGS: 'Transactions Logs',
			PAYMENTS: 'Billing',
			DATA_ROOM: 'Data Room',
			ASSEMBLIES: 'Assemblies',
			ASSEMBLY_ATTENDANCE: 'Assemblies Attendance',
			CAP_TABLE: 'Cap Table',
			MORTGAGES: 'Mortgages',
			BRAND_IDENTITY: 'Brand Identity',
			BOARDS: 'Boards',
			BOARD_MEETING: 'Board Meeting',
			COMMITTEES: 'Committees',
			MEETING_ATTENDANCE: 'Meeting Attendance',
			MEETING_DECISION_COMMENTS: 'Meeting Decision Comments',
			COMMENTS_ADDED_SUCCESS: 'Comments added successfully',
			CAPITALS: 'Capitals',
			DIVIDENDS: 'Dividends',
			COMMITTEE_MEETING: 'Committee Meetings',
			LOYALTY_PROGRAMS: 'Loyalty Programs',
		},
		COMMON: {
			EMAIL: 'Email',
			EMAIL_REQUIRED: 'Email is required',
			PASSWORD: 'Password',
			PASSWORD_REQUIRED: 'Password is required',
			PASSWORD_CONFIRMATION: 'Password Confirmation',
			PASSWORD_CONFIRMATION_REQUIRED: 'Password Confirmation is required',
			PASSWORDS_NOT_MATCH: "Password and password confirmation doesn't match",
			PASSWORD_MIN_8: "Password can't be less than 8 characters",
			DELETE: 'Delete',
			CONFIRM: 'Confirm',
			VIEW: 'View',
			CHANGE: 'Change',
			DISCARD: 'Discard',
			BACK: 'Go Back',
			UPLOAD: 'Upload',
			ADD: 'Add',
			CREATE: 'Create',
			SUCCESS: 'Success',
			ERROR: 'Error',
			OPS: 'Ops',
			FETCH_ERROR: 'An error occurred while fetching data.',
			SUBMIT_ERROR: 'An error occurred while submitting data.',
			ACTIONS: 'Actions',
			UPDATE: 'Update',
			PHONE_INVALID: 'Invalid phone number',
			PHONE_NUMBER: 'Phone number',
			PHONE_REQUIRED: 'Phone number is required',
			SAR: 'SAR',
			EDIT: 'Edit',
			SEARCH: 'Search',
			ID: 'ID',
			DOWNLOAD: 'Download',
			CANCEL: 'Cancel',
			N_A: 'N/A',
			NO_DATA: 'No Data',
			STATUS: 'Status',
			ONLY_PNG_JPG: 'Supports only PNG and JPG file formats.',
			ONLY_PDF: 'Supports only PDF file formats.',
			ACTIVE: 'Active',
			INACTIVE: 'Inactive',
			POWERED_BY: 'Powered by',
			TAKHAROJ_FINANCE: 'Takharoj Finance©',
			HEFTH_PLATFORM: 'Hefth Platform',
			NEXT: 'Next',
			NAME: 'Name',
			MAX: 'Max',
			GB: 'GB',
			MB: 'MB',
			KB: 'KB',
			B: 'Byte',
			REUPLOAD: 'Re-upload',
			LOGOUT: 'Logout',
			NOTE: 'Note',
			SELECT_DATE: 'Select date',
			WALLET: 'Wallet',
			PLAN: 'Plan',
			POINTS: 'Points',
			POINT: 'Point',
			SUBMIT: 'Submit',
			CURRENT_PASSWORD: 'Current password',
			SHAREHOLDER: 'Shareholder',
			NATIONAL_ID: 'National ID',
			FOUNDER: 'Founder',
			EXECUTIVE: 'Executive',
			BOARD_OF_DIRECTOR: 'Board of Directors',
			FULLY_PAID: 'Fully paid',
			COMMON: 'Common',
			COMMON_SHARES: 'Common Shares',
			PREFERRED: 'Preferred',
			PREFERRED_SHARES: 'Preferred Shares',
			TOTAL_COMMON: 'Total Common',
			TOTAL_PREFERRED: 'Total Preferred',
			FREE: 'Free',
			FREE_PRICE: 'Free',
			SUSPENDED: 'Suspended',
			MORTGAGED: 'Mortgaged',
			ACKNOWLEDGE:
				'I acknowledge and accept the terms and conditions, privacy policy, disclaimer and the refund policy in order to use this website.',
			SHAREHOLDER_FULL_NAME: 'Shareholder Full Name',
			SHARES: 'Shares',
			FREE_SHARES: 'Free Shares',
			SUSPENDED_SHARES: 'Suspended Shares',
			MORTGAGED_SHARES: 'Mortgaged Shares',
			NUM_OF_SHARES: 'Number of Shares',
			YES: 'Yes',
			NO: 'No',
			SAVE: 'Save',
			WELCOME: 'Welcome',
			ACTIVATE: 'Activate',
			SEND: 'Send',
			AMOUNT: 'Amount',
			CREATED_AT: 'Created At',
			PENDING: 'Pending',
			COMPLETED: 'Completed',
			FAILED: 'Failed',
			NOTIFICATIONS: 'Notifications',
			MARK_ALL_AS_READ: 'Mark all as read',
			GENERATE: 'Generate',
			DATE_OF_BIRTH: 'Date of Birth',
			TOTAL: 'Total',
			CHECK: 'Check',
			SHAREHOLDERS: 'Shareholders',
			TREASURY_SHARES: 'Treasury Shares',
			EXPORT_TO_EXCEL: 'Export to Excel',
			ALL: 'All',
			REJECTED: 'Rejected',
			CANCELED: 'Canceled',
			EXPIRED: 'Expired',
			START_DATE: 'Start Date',
			END_DATE: 'End Date',
			SHARE_PRICE: 'Share Price',
			TRANSACTION_TYPE: 'Transaction Type',
			TRANSACTIONS: 'Transactions',
			UPDATED_AT: 'Updated At',
			EQUITY: 'Equity',
			DATE_RANGE: 'Date Range',
			RESET: 'Reset',
			REMAINING_TRANSACTION: 'Remaining: {{num}} transactions',
			'UNDER-REVIEW': 'Under review',
			COUNTRY: 'Country',
			AVAILABLE: 'Available',
			DESCRIPTION: 'Description',
			TAB_TO_UPLOAD: 'Click to upload',
			UPLOAD_SUCCESSFUL: 'Upload successful',
			SENT: 'Sent',
			APPROVED: 'Approved',
			TYPE: 'Type',
			PUBLISHED: 'Published',
			SCHEDULED: 'Scheduled',
			COPY: 'Copy',
			ADDRESS: 'Address',
			EMAIL_ADDRESS: 'Email Address',
			FULL_NAME: 'Full Name',
			NATIONAL_ID_LENGTH: 'National ID must be 10 digits',
			FIELD_REQUIRED: 'This field is required',
			NUMBER_OF_SHARES_GREATER_THAN_ZERO: 'Number of shares must be greater than zero',
			ATTENTION: 'Attention',
			FIELD_LENGTH_VALIDATION: 'This field must be at least 12 characters.',
			ARABIC_ONLY: ' This field must be in Arabic only',
			ENGLISH_ONLY: 'This field must be in English only',
			MIN_VALUE_0: 'This field must be greater than or equal to 0',
			EMAIL_INVALID: 'Please enter a valid email address',
			BLOCKED: 'Blocked',
			DELETED: 'Deleted',
			RECAPTCHA_REQUIRED: 'Please complete the reCAPTCHA verification to proceed',
			RECORDS: 'records',
			DOWNLOAD_ERROR: 'An error occurred while downloading the file. Please try again later.',
			OTHER: 'Other',
			REVERSED: 'Reversed',
			SHARES_TYPE: 'Shares Type',
			FREE_PLAN: 'Basic',
			CLICK_TO_UPLOAD: 'Click to upload',
			UPLOAD_SUCCESSFULLY: 'Upload successfully',
			CANT_USED_MULTIPLE: 'This field cannot be used multiple times',
			GENERATED: 'Generated',
			ARABIC_DESC: 'Arabic Description',
			ENGLISH_DESC: 'English Description',
			UNDERREVIEW: 'Under Review',
			ONGOING: 'Ongoing',
			PREVIEW: 'Preview',
			NAME_AR: 'Arabic Name',
			NAME_EN: 'English Name',
			CANNOT_ACCESS_SERVICE: 'You cannot access this service',
			SEARCHING: 'Searching',
			NO_DATA_FOUND: 'No data found',
			PAYMENT_SUCCESS: 'Payment Successful',
			THANK_YOU: 'Thank you for your purchase!',
			PAYMENT_FAILED: 'Your payment didn’t go through',
			PAYMENT_FAILED_DESC: 'Please double-check your card details and try again.',
			REDIRECTING: 'You will be redirected in {{seconds}} seconds',
			BACK_TO_DASHBOARD: 'Back to Dashboard',
			REFERENCE_NUMBER: 'Reference Number',
			TOTAL_COMMON_SHARES: 'Total Common Shares',
			ONLY_XLSX: 'Only XLSX file format is supported',
			WAITING_ACTIVATION: 'Waiting Activation',
			AMENDMENTS: 'AMENDMENTS',
			DOCUMENT_AMENDMENTS: 'Document Amendments ',
			REGISTRY_AMENDMENTS: 'Registry Shareholders Amendments ',
			UNDER_REVIEW: 'Under Review',
			UPLOAD_REQUIREMENTS: 'Upload Requirements',
			DRAFT: 'Draft',
			CLOSE: 'Close',
			CONTINUE: 'Continue',
			PAYMENT_ERROR_GATEWAY: 'An error occurred with the payment gateway.',
			TRY_AGAIN: 'Please try again later.',
			NOT_FOUND_DESC: 'Sorry, the page you visited does not exist',
			UNAUTHORIZED_DESC: 'Sorry, you are not authorized to access this module, ask your administrator for permission.',
			CONFIRMATION: 'Confirmation',
			ALERT: 'Alert',
			CONTACT_ADMIN: 'Please contact the system administrator for assistance.',
			REFRESH_PAGE: 'Refresh Page',
			CHARGE: 'Charge',
			PENDINGPAYMENT: 'Pending Payment',
			PROCESSING: 'Processing',
			DISTRIBUTED: 'Distributed',
			EXECUTE: 'Execute',
			STANDING: 'Standing',
			TO_CHARGE: 'To charge your wallet or upgrade your plan please contact your account manager',
			CHECKING_PAYMENT_STATUS: 'Checking payment status',
			PAYMENT_SUCCESSFULLY: 'Payment completed successfully',
			CONTRACT: 'Contract',
			PAYMENT_CHECK: 'Payment Check',
			CHECKING_PAYMENT: 'Checking Payment in progress',
			PAYMENT_EXIST: 'Payment Exist',
			PAYMENT_NOT_EXIST: 'Payment Not Exist',
			BIRTH_DATE: 'Birth Date',
			PRICE: 'Price',
			TERMINATED: 'Terminated',
			WRITINGMINUTES: 'Writing Minutes',
			QUORUMNOTMET: 'Quorum Not Met',
			NOTHELD: 'Not Held',
			COMPANY_GENERAL_SUSPENDED: 'Company General Suspended',
			PENDINGAPPROVAL: 'Pending Approval',
			TANAQUL_APP: 'Tanaqul App',
			NO_NOTIFICATIONS: 'No notifications',
			COPY_PUBLIC_LINK: 'Copy Public Link',
		},
		LOGIN: {
			TITLE: 'Welcome Back',
			SUBTITLE: 'Enter your credentials to access your account',
			REMEMBER_ME: 'Remember me',
			REMEMBER_ME_FOR_30: 'Remember me for 30 days',
			FORGET_PASSWORD: 'Forget Password',
			LOGIN: 'Login',
			DONT_HAVE_ACCOUNT: "Don't have an account?",
			REGISTER_NOW: 'Register Now',
			INTRO_TITLE: 'Enhance Your Company Performance in Governance.',
			INTRO_SUBTITLE:
				"For decades companies all over the world have been seeking perfection in governance with Hefth those companies are steps a head in accomplishing that. With the first solution that covers almost all aspects of shareholder's affairs we promise you an astonishing experience.",
			REGISTER_COMPANY_ACCOUNT: 'Register Company Account',
			REGISTER_HEADER: 'Registration available only for companies with the following entities:',
			REGISTER_POINT_1: 'Closed joint stock',
			REGISTER_POINT_2: 'Simplified closed joint stock',
			REGISTER_POINT_3: 'Mixed closed joint stock',
			SHAREHOLDER_LOGIN: 'Shareholders login through Tanaqul app',
			INVALID_CREDENTIALS: 'The credentials provided are incorrect. Please verify your login information and try again.',
			HOME: 'Home',
		},
		RESET_PASSWORD: {
			HOME: 'Home',
			ENTER_PHONE: 'Enter your phone number',
			SEND_OTP: 'Send One Time Password',
			VERIFY_PHONE: 'Verify your phone number',
			OTP: 'One Time Password',
			RESEND_OTP: 'Re-send OTP',
			ENTER_PASSWORD: 'Enter your new password',
			PASSWORD_CHANGED: 'Your password has been successfully updated',
			REDIRECT_TO_HOME: 'You will be redirected to the homepage',
			REST_YOUR_PASSWORD: 'Reset your password',
			FILL_TO_RESET: 'Fill your data to can reset your account',
			RESET_PASSWORD: 'Reset Password',
			PHONE_NOT_REGISTERED: 'This phone number is not registered',
		},
		REGISTER: {
			CONTACT_PERSON: 'Contact Person',
			SUBTITLE: 'Details of the contact officer and the person who is authorized to sign',
			REPRESENTATIVE_NAME_AR: 'Representative Name in Arabic',
			REPRESENTATIVE_NAME_EN: 'Representative Name in English',
			REPRESENTATIVE_EMAIL: 'Representative Email	',
			REPRESENTATIVE_NATIONAL_ID: 'Representative National ID',
			REPRESENTATIVE_PHONE_NUMBER: 'Representative Phone Number',
			DO_YOU_HAVE_EMPLOYEE: 'Do you have a Hefth employee code?',
			HEFTH_EMPLOYEE_CODE: 'Hefth Employee Code',
			PERSON_INF: 'Person Information',
			AUTHORIZED_SIGNATORY_INF: 'Authorized Signatory Information',
			VERIFY_PHONE: 'Verify your phone number',
			ENTER_OTP: 'Please enter the OTP sent to ',
			RESEND_OTP: 'Re-send OTP',
			OTP_RESENT: 'OTP has been resent',
			PHONE_CHANGED: 'Your phone number has been updated. Please check for the OTP to verify.',
			CHANGE_PHONE_NUMBER: 'Change phone number',
			WRONG_NUMBER: 'Wrong number?',
			CHANGE_DESC: 'Change you phone number to complete the registration process',
			CREATE_COMPANY_PROFILE: 'Create your company profile 👋',
			FILL_COMPANY_DATA: 'Fill your data to create your company account',
			COMPANY_INF: 'Company Information',
			COMPANY_AR_NAME: 'Company Name in Arabic',
			COMPANY_EN_NAME: 'Company Name in English',
			COMPANY_TYPE: 'Company Type',
			SELECT_COMPANY_TYPE: 'Select Company Type',
			SELECT_COMPANY_TYPE_DESC: 'Please select your company type to continue',
			COMPANY_SECTOR: 'Company Sector',
			CAPITAL: 'Capital',
			AUTHORIZED_CAPITAL: 'Authorized Capital',
			AUTHORIZED_CAPITAL_VALIDATION: 'Authorized capital must be greater than or equal to capital',
			PAR_VALUE: 'Par-value',
			BOARD_MEMBER_NO: 'Number of Board Members',
			COMMERCIAL_REGISTRATION_NUMBER: 'Commercial Registration Number',
			COMMERCIAL_REGISTRATION_NUMBER_IF_EXISTS: 'Commercial Registration Number (if exists)',
			UNIFIED_REGISTRATION_NUMBER: 'Unified National Commercial Registration Number',
			VAT_REGISTRATION_NUMBER: 'VAT Register Number',
			COMPANY_ADDRESS: 'Company Address',
			COMPANY_LOGO: 'Company Logo',
			COMPANY_STAMP: 'Company Stamp',
			CHOOSE_PLAN: 'Please Choice Your Plan',
			START_NOW: 'Start now',
			FREE: 'Free',
			PAID_FEATURES: 'Paid features',
			ANNUALLY: 'Annually',
			UNLIMITED: 'Unlimited',
			SUBSCRIBE: 'Subscribe',
			SUBSCRIBE_PAYMENT: 'Subscribe and Payment',
			SUBSCRIBE_INITIATING_DATE: 'Subscription Initiating Date',
			SUBSCRIBE_INITIATING_DATE_DESC: 'this will determine the initiation of the contract in order to use the services.',
			CHOOSE_INITIATE_DATE: 'Choose Initiating Date',
			SUBSCRIPTION_NOTE:
				'you wont be able to execute any actions on your company until this date is met and payment irrelevant to such date, if business plan was chosen activation wont be granted till payment is fulfilled, this date restriction will include any services presented or offered to your shareholders in any platform related or connected to Hefth in any way or other. Please re-consider that in your selection and chose wisely.',
			THANKS_FOR_SUBSCRIPTION: 'Thank You for Subscription',
			PLEASE_DOWNLOAD: 'Please download the contract, sign it, and have it approved by the Chamber of Commerce.',
			HEFTH_SERVICES_AGREEMENTS: 'Hefth Services Use Agreement',
			DOWNLOAD_FIRST: 'Please download Hefth Services Use Agreement file first',
			COMMERCIAL_REGISTRATION_NUMBER_LEN: 'Commercial Registration Number must be 10 digits',
			UNIFIED_REGISTRATION_NUMBER_LEN: 'Unified National Commercial Registration Number must be 10 digits',
			VAT_REGISTRATION_NUMBER_LEN: 'VAT Register Number must be 15 digits',
			PAID: 'Paid',
			INVALID_OTP: 'Invalid OTP',
			THREE_WORDS_VALIDATION: 'name must contain at least three distinct words',
			PAR_VALUE_VALIDATION: 'Par value must be 0.5 or a whole number',
			BOARD_MEMBER_NO_MIN: 'Number of Board Members must be at least 3',
			BOARD_MEMBER_NO_MAX: 'Number of Board Members must be at most 11',
			BOARD_MEMBER_NO_INTEGER: 'Number of Board Members must be an integer',
			NATIONAL_ADDRESS: ' National Address',
			VERIFY_NOT_REBOT: 'Verify that you are not a reboot',
			COMPANY_MANAGER: 'Company Manager Information',
			CAPITAL_INFORMATION: 'Capital Information',
		},
		SIDEBAR: {
			MAIN_MENU: 'Main Menu',
			ACCOUNT_INFORMATION: 'Account Information',
			DASHBOARD: 'Dashboard',
			USER_PROFILE: 'User Profile',
			ADD_COMPANY_DOCUMENTS: 'Add Company Documents',
			VIEW_COMPANY_DOCUMENTS: 'View Company Documents',
			UPDATE_COMPANY_DOCUMENTS: 'Update Company Documents',
			SHAREHOLDERS_REGISTRY: 'Shareholder Registry',
			ADD_SHAREHOLDERS_REGISTRY: 'Add Shareholder Registry',
			VIEW_SHAREHOLDERS_REGISTRY: 'View Shareholder Registry',
			UPDATE_SHAREHOLDERS_REGISTRY: 'Update Shareholder Registry',
			ACTIONS: 'Actions',
			USERS_MANAGEMENT: 'Users Management',
			COMPANY_INFORMATION: 'Company Information',
			MORTGAGE_REQUEST: 'Mortgage Request',
			MORTGAGE_LIST: 'Mortgage List',
			PERSONAL_INFORMATION: 'Personal Information',
			PROFILE: 'Profile',
			SHAREHOLDERS_LIST: 'Shareholders List',
			CAP_TABLE: 'Cap Table',
			TRANSACTIONS_LOGS: 'Transactions Logs',
		},
		DOCUMENTS: {
			UPLOAD_DOCUMENTS: 'Upload Company Documents',
			DOCUMENTS_REVIEW: 'Company Documents Review',
			SUBSCRIPTION_CONTRACT: 'Subscription Contract in Hefth',
			PLEASE_UPLOAD: 'Please Upload the Following Documents',
			PLEASE_UPLOAD_DESC: 'In order to activate your account, please upload your company’s documents.',
			COMPANY_ESTABLISHMENT: 'Latest Company Articles of Association',
			VAT_REGISTRATION: 'VAT Registration Certificate',
			BOARD_OF_DIRECTORS: 'Board of Directors',
			COMMERCIAL_REGISTRATION: 'Commercial Registration',
			COMMERCIAL_REGISTRATION_IF_EXISTS: 'Commercial Registration if exists',
			APPROVED_AUTHORIZATION: 'Notarized Authorization for the Current User',
			BOARD_COMMITMENT: 'Board Committee Formation Resolutions (if any)',
			CHAIRMAN_SIGNATURE: 'Chairman Signature',
			CHAIRMAN_NAME_AR: 'Chairman Name in Arabic*',
			CHAIRMAN_NAME_EN: 'Chairman Name in English',
			AVERAGE_CURRENT_VALUE: 'Average current value of the share',
			CERTIFIED_COMPANY_VALUATION: 'Certified company valuation and share value (If any)',
			USER_ASSIGNMENT_FORM: 'User Assignment Form',
			AUTHORIZED_SIGNATORY_PERSON: 'Authorized Signatory Person',
			AUTHORIZED_SIGNATORY_PERSON_NAME: "Authorized signatory person's name",
			AUTHORIZED_SIGNATORY_PERSON_DESC: 'Updating the authorized signatory person name will cause the contract to be regenerated.',
			AUTHORIZED_SIGNATORY_NAME_UPDATED: 'Authorized signatory name has been updated successfully',
		},
		PROFILE: {
			PROFILE: 'Profile',
			CHANGE_PASSWORD: 'Change password',
			USER_PROFILE_INF: 'User profile information',
			UPDATE_YOUR_PROFILE: 'Update your profile',
			UPDATE_YOUR_PERSONAL_DETAILS: 'Update your personal details',
			SYSTEM_ADMIN_INF: 'System Admin Information',
			ORGANIZATION_NAME: 'Organization Name',
			ORGANIZATION_ID: 'Organization ID',
			SYSTEM_ADMIN_EMAIL: 'Organization Admin Email',
			SYSTEM_ADMIN_ID: 'Organization Admin ID',
			PASSWORD_CHANGED: 'Your password has been changed successfully',
			NUMBER_CHANGED: 'Your phone number has been changed successfully',
			OTP_SENT: 'An OTP has been sent to your phone number',
			PROFILE_UPDATED: 'Your profile data has been updated successfully',
		},
		SHAREHOLDERS_REGISTRY: {
			ADD: 'Add shareholder registry',
			ADDED: "Shareholders' register sent to the system",
			ADD_DESC: 'Add shareholders manually or upload whole registry to the system',
			DOWNLOAD_TEMPLATE: 'Download template',
			TOTAL_TREASURY_NUM: 'Total number of Treasury Shares',
			SAVE_FOR_LATER: 'Save for later',
			ADD_NEW_SHAREHOLDER: 'Add shareholder',
			ADD_ALL_DATA_MANUALLY: 'Please enter all shareholder data correctly',
			SEND_FOR_REVIEW: 'Send for review',
			UPLOAD_DATA: 'Upload Data',
			NONE: 'None',
			MEMBER: 'Member',
			CHAIRMAN: 'Chairman',
			TOTAL_TREASURY_SHARES_UPDATED: 'Total number of treasury shares updated successfully',
			SHAREHOLDER_ADDED: 'Shareholder added successfully',
			SHAREHOLDER_UPDATED: 'Shareholder updated successfully',
			SAVED_FOR_LATER: 'Shareholders list saved for later successfully',
			SENT_FOR_REVIEW_SUCCESS: 'Shareholders list sent for review successfully',
			DELETE_SHAREHOLDER_CONFIRM: 'Are you sure you want to delete this shareholder?',
			SHAREHOLDER_DELETED: 'Shareholder deleted successfully',
			TOTAL_SHAREHOLDERS: ' Total Shareholders',
			REMAINING_SHARES: 'Remaining Shares',
			MORE_SHARES_AVAILABLE: 'There are another {{shares}} shares that need to be distributed',
			EXCEEDS_REMAINING_SHARES: 'Exceeds the remaining shares: {{num}}',
			MAX_TREASURY_NUM: 'Treasury Share should not Exceed 10% of Total Shares',
			NO_DATA_ENTERED: 'No data entered',
			OWNED_SHARES: 'Owned Shares',
			SHAREHOLDER_COMMON_SHARES: 'Common shares owned by the shareholder',
			FREE: 'Free',
			SUSPENDED: 'Suspended',
			MORTGAGED: 'Mortgaged',
			TOTAL_OWNED_SHARES: 'Total Owned Shares',
			REMAINING: 'Remaining',
			FROM: 'From',
			ALL_SHARES_ALLOCATED: 'All {{num}} shares have been allocated',
			ALL_SHARES_ALLOCATED_TOOLTIP: 'All shares have been allocated',
		},
		DASHBOARD: {
			CURRENT_PLAN: 'Current plan',
			UPGRADE_TO_BUSINESS_PLAN: 'Upgrade to business plan ',
			ACCOUNT_UNDER_REVIEW: 'Your Account is Under Review',
			ACCOUNT_UNDER_REVIEW_DESC: 'The request is currently being reviewed and a message will be sent with the status of the request upon completion.',
			ACCOUNT_REJECTED: 'Your Account is Rejected',
			SHAREHOLDERS_REJECTED: 'The shareholders registry has been returned. Please verify its accuracy.',
			ACCOUNT_BLOCKED: 'Your Account is Blocked',
			UPDATE_DOCUMENT: 'Document Update Request',
			UPLOAD_VALID_DOCUMENTS: 'Please upload valid documents to review your account.',
			ACCOUNT_APPROVED: 'Your Account Approved',
			ACTIVATE_ACCOUNT: 'Dear User your account has been approved. please Activate it.',
			ACTIVATE_MODAL_TITLE: 'Start your subscription',
			ACTIVATE_MODAL_SUBTITLE: 'Please confirm start your subscription',
			START_DATE: 'Start Date',
			DAILY_CHANGE: 'Daily Change',
			AVERAGE_SALE_PRICE: 'Average Share Price',
			SHAREHOLDERS: 'Shareholders',
			TRANSACTIONS: 'Transactions',
			LAST_SHARE_PRICE: 'Last Share Price',
			TOTAL_SHARES: 'Total Shares',
			CAPITAL: 'Capital',
			NUMBER_OF_SHARES: 'Number of Shares',
			TREASURY_SHARES: 'Treasury Shares',
			YEAR: 'Year',
			ANNUAL_TRAFFIC: 'Annual Traffic',
			CUSTOMER_SUPPORT: 'Customer support',
			QUICK_ACTIONS: 'Quick Actions',
			ACCOUNT_MANGER_INF: 'Account Manager Info',
			FOR_ADMINISTRATIVE_SUPPORT: 'For Administrative support',
			TECHNICAL_SUPPORT: 'Technical Support',
			FOR_TECHNICAL_INQUIRY: 'For Technical Inquires',
			EMERGENCY_REQUEST: 'Emergency Request',
			EMERGENCY_ESCALATION: 'Emergency escalation to Hefth`s director (Please do not abuse this service)',
			CONTACT_INF: 'Contact Information',
			ACCOUNT_MANAGER_NAME: 'Account manager name',
			SEND_EMAIL_TO_TECH: 'Send Email to Tech Team',
			DESCRIPTION: 'Description',
			SEND_URGENT_REQUEST: 'Send Your Urgent Request',
			SEND_URGENT_REQUEST_DESC: 'send an urgent request to Hefth’s manager',
			REMAINING_MESSAGES: 'Remaining {{num}} message',
			MESSAGE: 'Message',
			SEND_EMAIL: 'Send Email',
			SEND_MESSAGE: 'Send Message',
			START_NOW: 'Start My Subscription Now',
			DAY: 'Day',
			WEEK: 'Week',
			MONTH: 'Month',
			SIX_MONTHS: '6 Months',
			LAST_PRICE: 'Last Price',
			TECHNICAL_SUPPORT_SUCCESS: 'Your technical support request has been sent successfully',
			TECHNICAL_SUPPORT_FAILED: 'Your technical support request has failed',
			EMERGENCY_REQUEST_SUCCESS: 'Your emergency request has been sent successfully',
			EMERGENCY_REQUEST_FAILED: 'Your emergency request has failed',
			NO_REMAINING_MESSAGES: 'You’ve reached your daily message limit',
			MESSAGE_TOO_SHORT: ' Please enter a longer message to proceed',
			SHAREHOLDERS_WAITING_APPROVAL: 'Shareholders are currently pending administrative approval',
			UPDATE_SHAREHOLDERS_REGISTRY_DESC: 'Please update your shareholders registry to activate your account',
			UPDATE_SHAREHOLDERS_REGISTRY: 'Update Shareholders Registry',
			PLEASE_ADD_SHAREHOLDERS: 'Please add the company shareholders registry',
			YOU_CAN_UPLOAD_SHAREHOLDERS: 'You can upload the shareholders registry and send it to the system',
			PLEASE_UPLOAD_DOCUMENTS: 'Please attach the company documents',
			YOU_CAN_UPLOAD_DOCUMENTS: 'You can upload the company documents and send them to the system',
			SHAREHOLDERS_UPLOADED: 'The company shareholders registry has been entered and sent to the system successfully and you can view it from here.',
			DOCUMENTS_UPLOADED: 'The company documents have been uploaded and sent to the system successfully and you can view them from here.',
			SHAREHOLDERS_APPROVED: 'The company shareholders registry has been approved successfully and you can view it from here.',
			SHAREHOLDERS_SHARES: 'Shareholder Shares',
			TOTAL_CAPITAL_SHARES: 'Total Capital Shares',
		},
		WALLET: {
			PACKAGE: 'Package',
			BASIC_PACKAGE: 'Basic Package',
			ADVANCED_PACKAGE: 'Advanced Package',
			BUSINESS_PACKAGE: 'Business Package',
			BUY_CUSTOM_POINTS: 'Buy Custom Points',
			BUY_NOW: 'Charge',
			INVOICE_NUMBER: 'Invoice Number',
			TRANSACTIONS: 'Transactions',
			GATEWAY: 'Gateway',
		},
		ACTIONS: {
			SHAREHOLDER_INFO: 'Shareholder Info',
			REGISTRY_TRANSACTIONS: 'Registry Transactions',
			HEIRS_TRANSFER: 'Heirs Transfer',
			SUSPEND: 'Suspend',
			NOTICE: 'Notice',
			ANNOUNCEMENT: 'Announcement',
			UPDATE_DOCUMENTS: 'Update Documents',
			FINANCIAL_STATEMENT: 'Financial Statement',
			NEW_REQUEST: 'New Request',
			VIEW_SHAREHOLDERS: 'To view shareholder information and create certificate',
			UNLIMITED: 'Unlimited',
			REQUEST_CODE: 'Request Code',
			REQUEST_DATE: 'Request Date',
			SHAREHOLDER_NATIONAL_ID: 'Shareholder National ID',
			SHAREHOLDER_NAME: 'Shareholder Name',
			FILL_TO_BUILD: 'To complete your request, please fill in the following fields.',
			SHAREHOLDER_FULL_NAME: 'Shareholder Full Name',
			SHAREHOLDER_CERTIFICATE: 'Shareholder certificate',
			SELLER_NATIONAL_ID: 'Seller National ID',
			SELLER_NAME: 'Seller Name',
			BUYER_NAME: 'Buyer Name',
			BUYER_NATIONAL_ID: 'Buyer National ID',
			TRANSFER_SHARES_DESC: 'To transfer shares between investors',
			AVAILABLE_SHARES: 'Available Shares',
			SHARES_COUNT: 'Shares Count',
			SHARE_PRICE: 'Share Price',
			DECEASED_EQUITY: 'Deceased equity distribution to heirs',
			NAME_OF_DECEASED: 'Name of deceased shareholders',
			FILL_DETAILS_TO_VALIDATE_ORDER: 'Fill out these details to Validate your order',
			DECEASED_NATIONAL_ID: 'Deceased National ID',
			DECEASED_EQUITY_INF: 'Deceased Equity Information',
			COUNT_OF_COMMON_SHARES: 'Count of Common Shares',
			COUNT_OF_PREFERRED_SHARES: 'Count of Preferred Shares',
			DETERMINE_HEIRS: 'Determine heirs',
			ESTATE_DISTRIBUTION: 'Estate Distribution',
			NO_OF_HEIRS: 'Number of heirs: {{num}}',
			HEIR: 'Heir',
			HEIR_NAME: 'Heir Name',
			ADD_HEIR: 'Add Heir ({{num}})',
			FREE_COMMON_SHARES_COUNT: 'Free Common Shares Count',
			FREE_PREFERRED_SHARES_COUNT: 'Free Preferred Shares Count',
			SUSPENDED_COMMON_SHARES_COUNT: 'Suspended Common Shares Count',
			SUSPENDED_PREFERRED_SHARES_COUNT: 'Suspended Preferred Shares Count',
			MORTGAGED_COMMON_SHARES_COUNT: 'Mortgaged Common Shares Count',
			MORTGAGED_PREFERRED_SHARES_COUNT: 'Mortgaged Preferred Shares Count',
			SUSPEND_COMPANY_SHARES: 'Suspend Company Shares',
			FOR_ALL: 'For All',
			GENERAL: 'General',
			GENERAL_SUSPEND: 'General Suspend',
			SPECIFIC_SUSPEND: 'Specific Suspend',
			ALL_COMPANY_SHARES: 'all company’s shares will be suspended from trading',
			SPECIFIC: 'Specific',
			SPECIFIC_INVESTOR_SHARES: 'Specific investor shares will be suspended from trading',
			GENERAL_SUSPENSION: 'General Suspension',
			SPECIFIC_SUSPENSION: 'Specific Suspension',
			SUSPEND_REASON: 'Suspend Reason',
			UPLOAD_DOCUMENTS: 'Upload Documents',
			UPLOADED_DOCUMENTS: 'Uploaded Documents',
			DOCUMENT_TITLE: 'Document Title',
			UPLOAD_ANOTHER_FILE: 'Upload another file',
			COST: 'Cost',
			REMAINING_TRANSACTIONS: 'Remaining Transactions',
			TRANSACTION: 'Transaction',
			TRANSACTIONS: 'Transactions',
			SUSPEND_ALL_COMMON_SHARES: 'Suspend All Common Shares',
			SUSPEND_ALL_PREFERRED_SHARES: 'Suspend All Preferred Shares',
			CANCELLED_AT: 'Cancelled At',
			BY: 'By',
			SEND_OFFICIAL_NOTICE: 'Send Official Notice',
			SEND_NOTICE_TO_ALL_SHAREHOLDERS: 'Send a notice to all shareholders',
			SEND_NOTICE_TO_SPECIFIC_SHAREHOLDER: 'Send a notice to specific shareholder',
			INVESTOR_MESSAGE: 'Investor Message',
			MESSAGE: 'Message',
			REMAINING: 'Remaining',
			DOCUMENT_TYPE: 'Document Type',
			TO_UPDATE_COMPANY_DOCUMENTS: 'To update company documents',
			UPDATE_COMPANY_DOCUMENT: 'Update Company Document',
			FILL_THESE_DETAILS_TO_UPDATE_COMPANY_DOCUMENTS: 'Fill out these details to update company documents',
			COMMERCIAL_REGISTRATION: 'Commercial Registration',
			LICENSES: 'Licenses',
			CURRENT_COMPANY_ESTABLISHMENT_CONTRACT: 'Current Company Establishment Contract',
			ADMINISTRATIVE: 'Administrative',
			CONTRACT: 'Contract',
			FINANCIAL: 'Financial',
			VAT_REGISTRATION_CERTIFICATE: 'VAT Registration Certificate',
			CHAIRMAN_SIGNATURE: 'Chairman Signature',
			SEND_FOR_REVIEW: 'Send for Review',
			SHOW_ON_PLATFORM_CONNECTED_TO_HEFTH: 'Show on platform connected to Hefth',
			TAX_REGISTRATION_NUMBER: 'Tax Registration Number',
			CHAIRMAN_NAME_AR: 'Chairman Name in Arabic',
			CHAIRMAN_NAME_EN: 'Chairman Name in English',
			APPOINTMENT_DECISION: 'Appointment Decision',
			CHAIRMAN_SIGNATURE_DESC: 'this signature will be displayed on certificates and other documents that carry the signature of the chairman',
			UPDATE_COMPANY_DOCUMENTS_DETAILS: 'Update Company Documents Details',
			ANNUAL: 'Annual',
			SEMI_ANNUAL: 'Semi-Annual',
			QUARTER: 'Quarter',
			TO_ADD_FINANCIAL_STATEMENTS: 'To add financial statements',
			PUBLISH_FINANCIAL_STATEMENT: 'Publish Financial Statement',
			FILL_TO_REVIEW: 'Fill out these details for review',
			ASSEMBLY_FILL_TO_REVIEW: 'Please fill in the data to schedule the assembly',
			PUBLIC: 'Public',
			PUBLIC_DESC: 'Publish financial statement to public in Hefth’s official site and company’s profile in mobile apps',
			TO_SENT_TO_SHAREHOLDERS: 'To be sent to company’s shareholders and company’s profile in mobile apps',
			PERIOD: 'Period',
			INTERNAL: 'Internal',
			AUDITED: 'Audited',
			UPLOAD_FINANCIAL_STATEMENT: 'Upload Financial Statement',
			FINANCIAL_STATEMENT_DETAILS: 'Financial Statement Details',
			AUDIENCE: 'Audience',
			YEAR: 'Year',
			QUARTER_ONE: 'Quarter One',
			QUARTER_TWO: 'Quarter Two',
			QUARTER_THREE: 'Quarter Three',
			QUARTER_FOUR: 'Quarter Four',
			PUBLISH_ANNOUNCEMENT: 'Publish your company’s announcement to public',
			NOTIFIED_BY_SMS: 'Notified by SMS',
			FREE_PUBLIC: 'Free Public',
			PUBLISH_TO_PUBLIC: 'Publish to Public in Hefth and related platforms',
			BROADCAST_ANNOUNCEMENT: 'Notify shareholders with SMS',
			NOTIFY_SHAREHOLDERS: 'Shareholders Notification',
			TRANSACTION_CALCULATOR: '{{shareholders}} users ✕ {{transactions}} points = {{total}} points',
			USAGE_CALCULATOR: 'Cost: {{cost}} transaction from {{remaining}} remaining transactions',
			COST_PER_SMS: 'Cost per SMS',
			POINT_PER_SMS: '{{point}} Point per SMS',
			TRANSACTIONS_PER_SMS: '1 transaction per SMS',
			ANNOUNCEMENT_DETAILS: 'Announcement Details',
			AWARE_THIS_CONTENT_BE_PUBLIC: 'Please be aware this content will be published to Public',
			TITLE_IN_AR: 'Title in Arabic',
			TITLE_IN_EN: 'Title in English',
			EXCERPT_IN_AR: 'Excerpt in Arabic',
			EXCERPT_IN_EN: 'Excerpt in English',
			CONTENT_IN_AR: 'Content in Arabic',
			CONTENT_IN_EN: 'Content in English',
			ADD_ANNOUNCEMENT_IN_ENGLISH: 'Add Announcement in English',
			ASSEMBLIES: 'Assemblies',
			TO_ADD_ASSEMBLIES: 'To add assemblies',
			FILL_TO_CREATE_ASSEMBLIES: 'Fill out these details to create assembly',
			TYPE_OF_ASSEMBLY: 'Type of Assembly',
			ORDINARY: 'Ordinary',
			ORDINARY_ASSEMBLY: 'Ordinary Assembly',
			EXTRAORDINARY: 'Extraordinary',
			EXTRAORDINARY_ASSEMBLY: 'Extraordinary Assembly',
			ATTENDANCE_QUORUM: 'Attendance Quorum',
			NON_ACCUMULATIVE_VOTING: 'Non-accumulative voting ',
			ACCUMULATIVE_VOTING: 'Accumulative Voting',
			CHOOSE_ASSEMBLY_DATE: 'Choose Assembly Date',
			TIME: 'Time',
			LOCATION: 'Location',
			ONLINE: 'Online',
			ONLINE_MEETING: 'Online Meeting',
			PHYSICAL: 'Physical',
			PHYSICAL_MEETING: 'Physical Location',
			AGENDA_FOR_MEETING: 'Assembly’s Agenda',
			ADD_ALL_FILES_TO_ASSEMBLY: 'Add all related files to be shared with shareholders.',
			ALL_FILES_TO_ASSEMBLY: 'all files related to assembly',
			POINT_IN_AR: 'Item in Arabic',
			POINT_IN_EN: 'Item in English',
			SHAREHOLDER_COUNT: 'Accumulative Vote',
			ADD_ANOTHER_POINT: 'Add another point',
			ADD_A_POINT: 'Add another point',
			ADDRESS: 'Address',
			ADDRESS_DESC: 'Address Description',
			ASSEMBLY_DATE: 'Assembly Date',
			ASSEMBLY_TYPE: 'Assembly Type',
			DIVIDENDS: 'Dividends',
			ELP: 'ELP (Soon)',
			CAPITALS: 'Capitals',
			MORTGAGE: 'Mortgage (Soon)',
			YES: 'Yes',
			NO: 'No',
			ABSTAINED: 'Abstained',
			ASSEMBLY_QUORUM_COMPLETE_PERCENTAGE: 'Assembly Quorum Complete Percentage',
			QUORUM_NOT_MET: 'Quorum not met',
			ASSEMBLY_QUORUM_NOT_COMPLETE: 'The assembly quorum is not complete yet',
			QUORUM_MET: 'Quorum met',
			COPY_LINK: 'Copy Link',
			ASSEMBLY_ATTENDANCE: 'Assembly Attendance',
			ATTEND_TYPE: 'Attend type',
			ASSEMBLY_SHAREHOLDER: 'Assembly Shareholder',
			ATTEND_AT: 'Attend at',
			SHAREHOLDER: 'Shareholder',
			COMPANYUSER: 'Company User',
			ASSEMBLY_ATTENDANT_DETAILS: 'Assembly Attendant Details',
			ATTEND_BY: 'Attend by',
			DELEGATE_NAME: 'Delegate Name',
			DELEGATION_DOCUMENT: 'Delegation Document',
			ADD_ASSEMBLY_ATTENDANCE: 'Add Assembly Attendance',
			SEARCH_BY_NATIONAL_ID_OR_NAME: 'Search by national ID or name',
			IS_DELEGATE_ATTENDANCE: 'Is delegate attendance',
			DELEGATE_FILE: 'Delegate File',
			OPEN_ATTENDANCE: 'Open Attendance',
			OPEN_VOTING: 'Open Voting',
			ADD_VOTE: 'Add Vote',
			DOWNLOAD_DOCUMENTS: 'Download Documents',
			VOTING_ITEMS: 'Voting Items',
			EACH_SHAREHOLDER_REPRESENT_ONE_VOTE: 'Each shareholder represents one vote',
			SHAREHOLDER_NOT_FOUND: 'Shareholder not found',
			SELLER_AND_BUYER_CANNOT_BE_SAME: 'Seller and buyer cannot be the same shareholder',
			SHARES_COUNT_REQUIRED: 'Shares count is required',
			SHARE_PRICE_REQUIRED: 'Share price is required',
			COMPANY_SHARES_LIMIT_EXCEEDED: 'Shares count exceeds the maximum available ({{count}} shares remaining)',
			SHAREHOLDER_LIMIT_EXCEEDED_TITLE: 'Shares limit exceeded',
			SHAREHOLDER_LIMIT_EXCEEDED_DESCRIPTION: 'The shares percentage exceeds the percentage allowed for shareholders and requires approval',
			SHAREHOLDER_LIMIT_EXCEEDED_APPROVE: 'I acknowledge my full awareness and the compliance of the process with the Cooperative Societies Law.',
			REGISTRY_TRANSACTION_CREATED: 'Registry transaction created successfully',
			HAS_PENDING_REQUEST: 'has pending request',
			UPDATE_DOCUMENT_SUCCESS: 'Update document request sent successfully',
			TAX_REGISTRATION_NUMBER_LEN: 'TAX Register Number must be 15 digits',
			VERIFICATION: 'Verification',
			CONFIRM_YOUR_REQUEST: 'Choose your verification method',
			PASSWORD: 'Password',
			OTP: 'OTP',
			SEND_OTP: 'Send OTP',
			ENTER_YOUR_PASSWORD: 'Enter your password',
			VALIDATE: 'Validate',
			OTP_SENT: 'An OTP has been sent to your phone number',
			OTP_NOT_SENT: 'An error occurred. when sending OTP to your phone number',
			FINANCIAL_STATEMENT_EXISTS: 'Financial statement for this period already exists',
			FINANCIAL_STATEMENT_CREATED: 'Financial statement created successfully',
			HEIR_TRANSFER_NOT_EXIST: 'Heir transfer request does not exist',
			SHAREHOLDER_GENERATED_SUCCESSFULLY: 'Shareholder generated successfully',
			HEIR_TRANSFER_CREATED: 'Heir transfer request created successfully',
			CANT_USED_DECEASED_NATIONAL_ID: 'This national ID belongs to the deceased person, so it cannot be used.',
			SELECT_ONE_AT_LEAST: 'Select at least one heir shareholder',
			ALL_SHARES_MUST_BE_DISTRIBUTED: 'All shares of the deceased must be distributed among the heirs before submitting',
			PENDING_TRANSACTION: 'Pending Transaction',
			PENDING_TRANSACTION_DESC: 'There are pending transactions for the deceased',
			PENDING_COMMON_SHARES: 'Pending Common Shares',
			PENDING_PREFERRED_SHARES: 'Pending Preferred Shares',
			CANCEL_PENDING_TRANSACTIONS: 'Cancel Pending Transactions',
			CANCEL_TRANSACTIONS_DECEASED: 'All pending transactions for the deceased will be canceled',
			PENDING_TRANSACTION_CANCELLED: 'Pending transactions for the deceased have been canceled successfully',
			CANCEL_REQUEST: 'Cancel Request',
			CANCEL_REQUEST_NOTE:
				'By confirming cancellation, all shareholders will be able to transfer their equity immediately. Please make sure it is a validated action.',
			CANCEL_SUSPEND_REASON: 'Cancel Suspend Reason',
			SUPPORTED_DOCUMENTS: 'Supported Documents',
			SUSPEND_ACTION_CANCELLED: 'Suspend action cancelled',
			SUSPEND_CREATED_SUCCESSFULLY: 'Suspend request created successfully',
			NOTICE_CREATED: 'Notice created successfully',
			MESSAGE_LENGTH_VALIDATION: 'Message length must be at least 10 characters',
			SMS_ENABLED: 'SMS Enabled',
			WHEN_YOU_PUBLISH: 'When you publish an SMS will sent to your shareholders',
			WAITING_FOR_PUBLISH: '(Waiting for Publication)',
			PUBLISH: 'Publish',
			CANCEL_ANNOUNCEMENT_PUBLISH_CONFIRMATION: 'Are you sure!',
			CANT_REPUBLISH_AGAIN: 'Cancel this announcement',
			ANNOUNCEMENT_CANCELLED_SUCCESSFULLY: 'Announcement cancelled successfully',
			ANNOUNCEMENT_PUBLISHED_SUCCESSFULLY: 'Announcement published successfully',
			CONFIRM_SEND_SHAREHOLDERS: 'Confirm you need to send sms to shareholders.',
			I_AGREE_TO_TERMS: 'I agree to the terms and conditions and privacy policy.',
			AGREE_FIRST: 'Please agree to the terms and conditions first.',
			ANNOUNCEMENT_CREATED: 'Announcement created successfully',
			CANCEL_ASSEMBLY: 'Cancel Assembly',
			CONFIRM_CANCEL_ASSEMBLY: 'Are you sure you want to cancel this assembly?',
			ASSEMBLY_CANCELLED: 'Assembly is cancelled successfully',
			ASSEMBLY_NOT_CANCELLED: 'An error occurred while cancelling the assembly.',
			CANT_UNDO: 'The assembly cannot be restored after it has been cancelled',
			SEARCH_FOR_PLACE: 'Search for a place',
			PRESIDENT_OF_ASSEMBLY_NAME: 'President of assembly',
			GENERAL_SECRETARY_NAME: 'Secretary name',
			VOTE_COLLECTOR_NAME: 'Vote counter name',
			PRESIDENT_OF_ASSEMBLY_SIGNATURE: 'President of assembly signature',
			GENERAL_SECRETARY_SIGNATURE: 'Secretary signature',
			VOTE_COLLECTOR_SIGNATURE: 'Vote counter signature',
			QUORUM_PERCENTAGE: 'Quorum Percentage',
			BOARD_ABSTENTION: 'Board abstention',
			SELECT_AT_LEAST_ONE_LOCATION: 'Select at least one location',
			ASSEMBLY_CREATED: 'Assembly created successfully',
			ASSEMBLY_UPDATED: 'Assembly updated successfully',
			SIGNATURE: 'Signature',
			ERROR_FETCHING_ASSEMBLY: 'An error occurred while fetching assembly data.',
			ATTENDANCE: 'Attendance',
			VOTING_OPENED_SUCCESS: 'Voting opened successfully',
			VOTING_OPENED_FAILED: 'Voting failed to open',
			ATTENDANCE_OPENED_SUCCESS: 'Attendance opened successfully',
			ATTENDANCE_OPENED_FAILED: 'Attendance failed to open',
			COMPANY: 'Company',
			ATTENDEES: 'Attendees',
			OWNS: 'Owns',
			DECISION_IN_AR: 'Decision in Arabic',
			DECISION_IN_EN: 'Decision in English',
			DECISION: 'Decision',
			CURRENT_VOTING_RESULT: 'Current voting result',
			ATTENDANCE_VOTING_STATUS: 'Attendance voting status',
			VOTED_USERS: 'Voted Users',
			NO_VOTE: 'No Vote',
			NOVOTE: 'No Vote',
			NUMBER_OF_SHAREHOLDER_ADDED_VOTES: 'Number of shareholder added votes',
			NUMBER_OF_SHAREHOLDER_ADDED_NO_VOTES: 'Number of shareholder added no votes',
			ERROR_ENDING_VOTING: 'An error occurred while ending voting.',
			CLOSE_VOTING: 'Close Voting',
			CLOSE_ASSEMBLY: 'Close Assembly',
			COPIED: 'Copied',
			COST_POINTS: 'Cost {{num}} Points',
			FREE_ACTIONS: 'Free Actions',
			UPGRADE_TO_PLAN: 'Upgrade to {{name}} plan',
			VOTTING_DETAILS: 'Voting Details',
			ATTENDEE_ADDED_SUCCESSFULLY: 'Attendee added successfully',
			VOTING_ENDED_SUCCESSFULLY: 'Voting ended successfully',
			ASSEMBLY_CLOSED_SUCCESSFULLY: 'Assembly closed successfully',
			ERROR_CLOSING_ASSEMBLY: 'An error occurred while closing the assembly.',
			QUORUM_MUST_BE_ATLEAST: 'Attendance Quorum must be at least {{num}}%',
			CANT_ACCESS_ASSEMBLIES_SERVICE: 'You do not have access to the assemblies services.',
			DISCOUNT: 'Discount',
			FETCH_DECISION_ERROR: 'An error occurred while fetching decisions data.',
			SUBMIT_SHAREHOLDER_VOTE: 'Submit Shareholder Vote',
			VOTE_ADDED_SUCCESSFULLY: 'Vote added successfully',
			ASSEMBLY_FILES: 'Assembly Files',
			DOWNLOAD_ASSEMBLY_FILES: 'Download assembly files',
			COMPLETION_PROGRESS: 'Completion Progress',
			AVAILABLE_FILES: '{{num}} of 4 files available',
			ATTENDANCE_PDF: 'Attendance PDF',
			DECISIONS_RESULTS_PDF: 'Decisions Results PDF',
			SHAREHOLDER_VOTING_CARDS: 'Shareholder Voting Cards',
			DECISIONS_COMMENTS_PDF: 'Decisions Comments PDF',
			NOT_READY_YET: 'Not Ready Yet',
			AUTO_PUBLISH: 'Auto Publish',
			DAYS: 'Days',
			HOURS: 'Hours',
			MINUTES: 'Minutes',
			SECONDS: 'Seconds',
			AUTO_PUBLISH_TIME: 'Auto Publish Time',
			DECISIONS: 'Decisions',
			ALL_DECISIONS_IN_ASSEMBLY: 'All decisions in the assembly',
			ASSEMBLY_LESS_THAN_21_DAYS_WARNING:
				'The Saudi Companies Law stipulates - Article Ninety-One - Paragraph One - that shareholders must be invited to the General Assembly at least 21 days before the specified date, and scheduling it and meeting before that falls under the sole responsibility of the company.',
			COMPANY_SUSPEND: 'Company Suspend',
			SYSTEM_SUSPEND: 'System Suspend',
			SYSTEM_SUSPEND_DESC:
				'Actions automatically carried out by the system in accordance with the regulations in force within the Kingdom of Saudi Arabia.',
			TYPE: 'Type',
			FOUNDER: 'Founder',
			UNDER_AGE: 'Under Age',
			FIRST_YEAR_AUDITED_STATEMENT: 'First Year Audited Statement',
			SECOND_YEAR_AUDITED_STATEMENT: 'Second Year Audited Statement',
			ALL_SHARES_SUSPENDED: 'All Shares Suspended',
			ASSEMBLY_PUBLISHED_SUCCESSFULLY: 'Assembly published successfully',
			ERROR_PUBLISHING_ASSEMBLY: 'An error occurred while publishing the assembly.',
			BOARDS_AND_COMMITTEES: 'Boards and Committees',
			BOARDS: 'Boards',
			COMMITTEES: 'Committees',
			BOARDS_DESC: 'Fill out these details to build your Company',
			APPOINT_BOARD: 'Appoint Board',
			ACTIVE_BOARD: 'Active Board',
			BOARD: 'Board',
			DRAFT_BOARD: 'Draft Board',
			BOARD_GOVERNANCE: 'Board Governance',
			BOARD_SETTINGS: 'Board Settings',
			TOTAL_BOARD_MEMBERS: 'Total Board of Directors Members',
			BOARD_OF_DIRECTORS_TERM: 'Board of Directors Term',
			BOARD_OF_DIRECTORS_TERM_VALIDATION: 'Board of Directors Term must be at least 1 year',
			MAXIMUM_EXECUTIVE_MEMBERS: 'Maximum Executive Members',
			MAXIMUM_INDEPENDENT_MEMBERS: 'Maximum Independent Members',
			MINIMUM_QUORUM_OF_MEETINGS: 'Minimum Quorum of Meetings',
			MAXIMUM_ABSENCE_BEFORE_NOTIF: 'Maximum Absence Before Notif.',
			MINIMUM_NOTIF_BEFORE_MEETINGS: 'Minimum Notif. Before Meetings.',
			ALLOW_SWIPE_VOTING: 'Allow Swipe Voting',
			BOARD_MEMBERS: 'Board Members',
			MEMBERS: 'Members',
			MEETINGS: 'Meetings',
			YEARS: 'Years',
			BOARD_MEETINGS: 'Board Meetings',
			BOARD_APPOINTMENT: 'Board Appointment',
			MEMBER_NAME: 'Member Name',
			MEMBER_NAME_AR: 'Member Name In Arabic',
			MEMBER_NAME_EN: 'Member Name In English',
			POSITION: 'Position',
			APPOINTMENT_DATE: 'Appointment Date',
			BOARD_STRUCTURE: 'Board Structure',
			FILL_TO_APPOINT_BOARD: 'Fill out these details to appoint Company’s Board of directors',
			BOARD_MEMBER_NAME: 'Board Member Name',
			PLEASE_CHOOSE_BOARD_GOVERNANCE: 'Please Choose Board Governance.',
			OPTIONAL_SETTINGS_TO_ENHANCE_BOARD_PERFORMANCE: 'Optional Settings to Enhance Board Performance',
			ALLOW_EXTERNAL_GUEST_INVITATION: 'Allow External Guest Invitation',
			ALLOW_SECRETARY_UPDATE_WHILE_BOARD_IS_ACTIVE: 'Allow Secretary Update while Board is Active',
			ADD_BOARD_MEMBERS: 'Please Add Board Members.',
			ADD_MEMBER: 'Add Member',
			ADD_NEW_MEMBER: 'Add New Member',
			MEMBER_NATIONAL_ID: 'Member National ID',
			MEMBER_PHONE: 'Member Phone Number',
			MEMBER_EMAIL: 'Member Email',
			MEMBER_TYPE: 'Member Type',
			MEMBER_POSITION: 'Member Position',
			EXECUTIVE: 'Executive',
			NON_EXECUTIVE: 'Non-Executive',
			'NON-EXECUTIVE': 'Non-Executive',
			INDEPENDENT: 'Independent',
			STAFF: 'Staff',
			CHAIRMAN: 'Chairman',
			VICE_CHAIRMAN: 'Vice Chairman',
			SECRETARY: 'Secretary',
			TREASURER: 'Treasurer',
			MEMBER: 'Member',
			DELETE_MEMBER: 'Delete Member',
			CONFIRM_DELETE_MEMBER: 'Please confirm your request',
			MEMBER_DELETE_NOTE:
				'Member deletion will be effective after saving all changes, please be aware that after saving all changes this member can not be in the board unless you re-add him again.',
			MEMBER_DETAILS: 'Member Details',
			TOTAL_BOARD_MEMBERS_VALIDATION: 'The board must have at least 3 members and not exceed 15 members.',
			MAXIMUM_ABSENCE_BEFORE_NOTIF_VALIDATION: 'Maximum absence before notification must not exceed 50% of the board meetings.',
			MINIMUM_NOTIF_BEFORE_MEETINGS_VALIDATION: 'Minimum notification before meetings must be at least 1 day.',
			MINIMUM_QUORUM_OF_MEETINGS_VALIDATION: 'Minimum quorum of meetings must not be less than 50%.',
			BOARD_MEMBER_CREATED_SUCCESSFULLY: 'Board member created successfully',
			BOARD_MEMBER_UPDATED_SUCCESSFULLY: 'Board member updated successfully',
			BOARD_MEMBER_DELETED_SUCCESSFULLY: 'Board member deleted successfully',
			FETCH_BOARD_DETAILS_ERROR: 'An error occurred while fetching board details.',
			BOARD_APPOINTMENT_FAILED: 'Board appointment failed. Please try again later.',
			BOARD_APPOINTED_SUCCESSFULLY: 'Board appointed successfully',
			BOARD_CREATED_SUCCESSFULLY: 'Board created successfully',
			BOARD_APPOINTMENT_VERIFICATION_NOTE:
				'Appoint new board  will be effective after you confirm, Please be aware: according to Saudi MOC Laws,new company board appointment must be approved by the Assembly.',
			BOARD_DELETED_SUCCESSFULLY: 'Board deleted successfully',
			BOARD_DELETED_FAILED: 'An error occurred while deleting the board.',
			DELETE_BOARD: 'Delete Board',
			CONFIRM_DELETE_BOARD: 'Please confirm your request to delete the board.',
			BOARD_DELETE_NOTE:
				'Board deletion will be effective immediately, please be aware that after deleting the board all its data will be lost and cannot be restored.',
			NEW_MEETING: 'New Meeting',
			MEETING_DATE: 'Meeting Date',
			BOARDS_MEETINGS: 'Boards Meetings',
			CODE: 'Code',
			NEW_BOARD_MEETING: 'New Board Meeting',
			MEETING_FILL_OUT_DETAILS: 'Fill out these details to schedule new meeting',
			MEETING_TYPE: 'Meeting Type',
			SCHEDULED: 'Scheduled',
			URGENT: 'Urgent',
			VOTING: 'Voting',
			FOR_SCHEDULED_MEETINGS: 'For scheduled meetings',
			IMMEDIATE_ACTION_NEEDED: 'Meeting with immediate action needed',
			NO_DELIBERATION_VOTES: 'No Deliberation, votes on decisions.',
			CHOOSE_STARTING_DATE: 'Choose Starting date',
			GUEST_INVITATION: 'Guest Invitation',
			EXTERNAL_BODIES_NO_VOTING_RIGHTS: 'External Bodies to Join with no Voting Rights',
			INVITE: 'Invite',
			NAME: 'Name',
			ORGANIZATION: 'Organization',
			ADD_NEW_GUEST: 'Add New Guest',
			GUEST_DETAILS: 'Guest Details',
			GUEST_NAME_AR: 'Guest Name in Arabic',
			GUEST_NAME_EN: 'Guest Name in English',
			GUEST_EMAIL: 'Guest Email',
			GUEST_PHONE: 'Guest Phone Number',
			GUEST_SECTOR: 'Guest Sector',
			GUEST_POSITION: 'Guest Position',
			GUEST_ORGANIZATION: 'Guest Organization',
			DELETE_GUEST: 'Delete Guest',
			CONFIRM_DELETE_GUEST: 'Please confirm your request to delete the guest.',
			EDIT_MEMBER: 'Edit Member',
			EDIT_GUEST: 'Edit Guest',
			MEETING_AGENDA: 'Meeting Agenda',
			SCHEDULE: 'Schedule',
			MEETING_CREATED_SUCCESSFULLY: 'Meeting created successfully',
			VOTING_DURATION: 'Voting Duration',
			MINUTES_VAR: '{{num}} Minutes',
			HOURS_VAR: '{{num}} Hours',
			HRS: 'Hrs',
			MINS: 'Mins',
			CANCEL_MEETING: 'Cancel Meeting',
			MEETING_CANCELLED: ' Meeting cancelled successfully',
			CONFIRM_CANCEL_MEETING: 'Are you sure you want to cancel this meeting?',
			MEETING_NOT_CANCELLED: 'An error occurred while cancelling the meeting.',
			CONFIRM_OPEN_VOTING: 'Are you sure you want to open voting for this meeting?',
			CONFIRM_OPEN_ATTENDANCE: 'Are you sure you want to open attendance for this meeting?',
			MEETING_UPDATED_SUCCESSFULLY: 'Meeting updated successfully',
			STARTING_DATE: 'Starting Date',
			STARTING_DATE_BUY: 'Starting Date',
			ATTENDING_MEMBERS: 'Attending Members',
			MEETING_GUESTS: 'Meeting Guests',
			GUESTS: 'Guests',
			MEETING_QUORUM_MET: 'Meeting quorum met',
			MEETING_QUORUM_NOT_MET: 'Meeting quorum not met',
			MEETING_FILES: 'Meeting Files',
			ATTENDANCE_SUMMARY: 'Attendance Summary',
			ADD_MEETING_ATTENDANCE: 'Add Meeting Attendance',
			MEETING_ATTENDANCE: 'Meeting Attendance',
			MEETING_ATTENDANT_DETAILS: 'Meeting Attendant Details',
			END_VOTING: 'End Voting',
			END_MEETING: 'End Meeting',
			CONFIRM_END_MEETING: 'Are you sure you want to end this meeting?',
			CONFIRM_CLOSE_VOTING: 'Are you sure you want to close voting for this meeting?',
			VOTING_CLOSING_SUCCESS: 'Voting closed successfully',
			MEETING_ENDED_SUCCESSFULLY: 'Meeting ended successfully',
			ADD_DECISION_COMMENTS: 'Add Decision Comments',
			EDIT_DECISION_COMMENTS: 'Edit Decision Comments',
			MEETING_DECISION_COMMENTS: 'Meeting Decision Comments',
			COMMENTS_ADDED_SUCCESS: 'Comments added successfully',
			PREVIOUS_BOARD: 'Previous Board',
			USERS: 'Users',
			USER: 'User',
			ATTENDEE_TYPE: 'Attendee Type',
			UPDATE_SECRETARY_ERROR: 'An error occurred while updating secretary information.',
			SECRETARY_UPDATED_SUCCESSFULLY: 'Secretary information updated successfully',
			UPDATE_SECRETARY: 'Update Secretary',
			ASSEMBLY_DESCRIPTION: 'Schedule a new general or special assembly',
			NUMBER_OF_MEMBER_ADDED_NO_VOTES: 'Number of member added no votes',
			NUMBER_OF_MEMBER_ADDED_VOTES: 'Number of member added votes',
			BOARD_DOCUMENTS: 'Board Documents',
			NEW_DOCUMENT: 'New Document',
			FILES_COUNT: 'Files Count',
			TITLE: 'Title',
			DOCUMENT_DETAILS: 'Document Details',
			DESCRIPTION_IN_ARABIC: 'Description in Arabic',
			DESCRIPTION_IN_ENGLISH: 'Description in English',
			DELETE_DOCUMENT: 'Delete Document',
			CONFIRM_DELETE_DOCUMENT: 'Please confirm your request to delete the document.',
			DOCUMENT_DELETED_SUCCESSFULLY: 'Document deleted successfully',
			ERROR_DELETING_DOCUMENT: 'An error occurred while deleting the document.',
			NEW_BOARD_DOCUMENT: 'New Board Document',
			DOCUMENT_CREATED_SUCCESSFULLY: 'Document created successfully',
			UPDATE_BOARD_DOCUMENT: 'Update Board Document',
			DOCUMENT_UPDATED_SUCCESSFULLY: 'Document updated successfully',
			ABSTENTION_TYPE: 'Abstention Type',
			NONE: 'None',
			ALL_BOARD_MEMBERS: 'All Board Members',
			SPECIFIC_SHAREHOLDERS: 'Specific Shareholders',
			SPECIFIC_BOARD_MEMBER: 'Specific Board Member',
			ADD_ACTIVE_BOARD_TO_ADD_DOCUMENT: 'Please activate board to add documents.',
			ADD_ACTIVE_BOARD_TO_ADD_MEETING: 'Please activate board to hold meetings.',
			BOARD_CREATION_NOTE:
				'Dear user … you can not change board governance and settings after submitting it. In order to change it you need to delete the draft and start the action all over',
			DISSENT: 'Dissent',
			BOARD_MEMBER: 'Board Member',
			EMPLOYEE_WHO_HAS_REGISTERED: 'Employee who has registered',
			ABSTENTION_FROM_VOTING: 'Abstention from Voting',
			ACCEPTED: 'Accepted',
			APPLICATION: 'Application',
			CONFIRM_SUBMIT_VOTE_NOTE: 'Please make sure that you choose the right voting, by sending you will not be able to edit it.',
			FINAL_VOTING_RESULT: 'Final Voting Result',
			TIE: 'Tie',
			INSUFFICIENT_BALANCE: 'Insufficient balance.',
			BALANCE: 'Balance',
			DECISION_FAILED: 'Decision failed',
			RAISE: 'Raise',
			DECREASE: 'Decrease',
			RAISE_CAPITAL: 'Raise Capital',
			AUTHORIZED_CAPITAL: 'Authorized Capital',
			ISSUED_CAPITAL_IS: 'Issued Capital is',
			WHICH_IS: 'which is',
			OF_AUTHORIZED_CAPITAL: 'of Authorized Capital',
			INCREASE_AUTHORIZED: ' Update Authorized Capital',
			PROFIT_CAPITALIZATION: 'Profit Capitalization',
			PROFIT_CAPITALIZATION_DESC: ' Issuing free new share to all shareholders by capitalizing retained profits.',
			TREASURY_SHARES_ACQUISITION: 'Treasury Shares Acquisition',
			TREASURY_SHARES_ACQUISITION_DESC: 'Place a buy order with all shareholders to acquire treasury shares.',
			PRIVATE_EQUITY_ISSUANCE: 'Private Placement',
			PRIVATE_EQUITY_ISSUANCE_DESC: 'New shares to KNOWN new investors.',
			TYPE_OF_RAISE: 'Type of Raise',
			ELIGIBILITY_DATE: 'Eligibility Date',
			MINIMUM_CAPITAL_RAISE: 'Minimum Capital Raise %',
			TOTAL_NUMBER_OF_UNIT_ISSUED: 'Total Number of Units Issued',
			TO_AVOID_FRACTIONS: 'To avoid fractions, the system automatically adjusts the percentage and units.',
			TOTAL_CAPITAL_RAISE: 'Total Capital Raise',
			DISTRIBUTION_DATE: 'Distribution Date',
			OTP_SEND_FAILED: 'Failed to send OTP, please try again later.',
			CHECK_CAPITAL_RATIO_ERROR: 'An error occurred while checking capital raise ratio.',
			CAPITAL_RAISE_CANCELLED: 'Capital raise cancelled successfully',
			CANCEL_CAPITAL_RAISE: 'Cancel Capital Raise',
			CONFIRM_CANCEL_CAPITAL_RAISE: 'Are you sure you want to cancel this capital raise?',
			PROFIT_CAPITALIZATION_CREATED_SUCCESSFULLY: 'Profit Capitalization Request was Performed Successfully!',
			CAPITAL_RAISE_NOT_CANCELLED: 'Capital raise not cancelled',
			CAPITAL_RAISE: 'Capital Raise',
			TRANSACTION_FRACTIONS: 'Transaction Fractions',
			TRANSACTION_FRACTIONS_DESC: 'Fractions of shares calculated and summed with detailed ownership',
			FRACTION_SHARES: 'Fraction Shares',
			OWNERS: 'Owners',
			FRACTIONS_OWNERS: 'Fractions Owners',
			IBAN: 'IBAN',
			FRACTION_TRANSFER_TITLE: 'Fractions Should be Sold and Money Collected By the Company',
			FRACTION_TRANSFER_DESC: 'transferring this Fractions will be carried immediately please make sure you do it RIGHT!',
			CREATE_TRANSFER_REQUEST: 'Create Transfer Request',
			FRACTION_TRANSFER: 'Fraction Transfer',
			TRANSFER: 'Transfer',
			PRICE_PER_SHARE: 'Price per Share',
			COUNT_OF_SHARES: 'Count of Shares',
			TRANSFER_REQUEST_CREATED_SUCCESSFULLY: 'Transfer request created successfully',
			ERROR_CREATING_TRANSFER_REQUEST: 'An error occurred while creating transfer request.',
			BUYER_ACCEPTANCE_STATUS: 'Buyer Acceptance Status',
			CREATE_NEW_REQUEST: 'Create New Request',
			UPDATE_AUTHORIZED_CAPITAL: 'Update Authorized Capital',
			CURRENT_AUTHORIZED_CAPITAL: 'Current Authorized Capital',
			NEW_AUTHORIZED_CAPITAL: 'New Authorized Capital',
			ISSUED_CAPITAL: 'Issued Capital',
			AUTHORIZED_CAPITAL_UPDATED_SUCCESSFULLY: 'Authorized capital updated successfully',
			OF_NEW_AUTHORIZED_CAPITAL: ' of New Authorized Capital',
			IS_BEYOND_AUTHORIZED_CAPITAL: ' is beyond Authorized Capital',
			NO_ACTIVE_BOARD_EXIST: 'No active board exist.',
			CAPITALS_MANAGEMENT: 'Capitals Management',
			ALLOW_YOU_TO_PERFORM_RAISE_OPERATION: 'Allow you to perform raise capital operations',
			FILL_THE_FOLLOWING_TO_PROCESS_REQUEST: 'Fill the following to process your request',
			AGREEMENT_TO_TERMS_CAPITALS: 'I acknowledge and agree to the Terms and Conditions of Capital Operation.',
			PROFIT_CAPITALIZATION_NOTE:
				'New shares will be distributed in the distribution date and will not be reversible. Please be aware extraordinary assembly approval is mandatory as per Saudi laws.',
			UPDATE_AUTHORIZED_NOTE:
				'Authorized Capital will be updated immediately. Please be aware that this action has to be approved by Extraordinary Assembly as per Saudi laws.',
			CAPITAL_RAISE_NOT_CREATED: 'Capital raise request not created',
			PROFIT_CAPITALIZATION_NOT_UPDATED: 'Profit Capitalization request not updated',
			PROFIT_CAPITALIZATION_UPDATED_SUCCESSFULLY: 'Profit Capitalization Request was Updated Successfully!',
			PROFIT_CAPITALIZATION_NOT_CREATED: 'Profit Capitalization request not created',
			DIVIDENDS_DESC: 'To manage dividends operations',
			DISTRIBUTION_INTERVAL: 'Distribution Type',
			INTERIM_DIVIDENDS: 'Interim Dividends ',
			ANNUAL_DIVIDENDS: 'Annual Dividends',
			REVENUE_PER_SHARE: 'Dividend Per Share',
			TOTAL_AMOUNT_OF_DIVIDENDS: 'Total Amount of Dividends',
			TERMS_AND_CONDITIONS: 'Terms & conditions',
			AGREE_TERMS_AND_CONDITIONS: 'I agree to the terms and conditions of the dividend distribution.',
			THREE_DAYS_PAYMENT: '3 days payment condition',
			FAILURE_TO_PAY_SDAD_BILL: 'I agree that payment should be 3 days prior to the distribution date to avoid auto cancellation.',
			GENERATE_BILL: 'Generate Bill',
			DIVIDENDS_CREATED: 'Dividends created successfully',
			CONFIRM_DIVIDEND_CREATION: 'Dividends Distribution Request Confirmation',
			DIVIDENDS_NOTE:
				'Please be aware that this request once paid and distributed will not be reversible. in case of payment and cancellation before distribution, Hefth will deduct 1% or 1500 Saudi Riyals whichever higher as service cancellation fees.',
			PLEASE_CONFIRM_YOUR_REQUEST: 'Please confirm your request',
			INTERVAL: 'Interval',
			ORDER_ID: 'Order ID',
			SHAREHOLDERS_DIVIDENDS_LIST: 'Shareholders Dividends List',
			DIVIDEND_CANCELLED_SUCCESS: 'Dividends Distribution Request was Cancelled Successfully !',
			DIVIDEND_NOT_CANCELLED: 'Dividend Request not cancelled',
			CANCEL_DIVIDEND: 'Cancel Dividend',
			CONFIRM_CANCEL_DIVIDEND: 'Are you sure you want to cancel this dividend?',
			CONFIRM_CANCEL_PENDING_DIVIDEND: 'Cancel Pending Dividends Distribution Request Confirmation',
			CONFIRM_CANCEL_SCHEDULED_DIVIDEND: 'Cancel Scheduled Dividends Distribution Request Confirmation',
			SCHEDULED_DIVIDEND_CANCEL_NOTE:
				'Please be aware that Hefth will deduct 1% or 1500 whichever higher as administrative service cancellation fees. the remaining of your payment will be transferred to your company’s IBAN within 72 working hours.',
			TOTAL_TREASURY_SHARES_TO_BE_BOUGHT: 'Total number of Treasury share to be Bought',
			CAN_NOT_EXCEED_FAILED: 'Can not exceed 10% of Total equity  Remaining: {{remaining}} shares',
			CAN_NOT_EXCEED_SUCCEED: 'Can not exceed 10% of Total equity',
			CURRENT_PERCENTAGE: 'Current: {{currentPercentage}}%',
			REMAINING_SHARES: 'Remaining: {{remaining}} shares',
			DIVIDENDS_UPDATED: ' Dividends updated successfully',
			DATE_MIN_3_DAYS: ' The distribution date must be at least 3 days from today ',
			PRICE: 'Price / Share',
			TRADING_DAYS: 'Trading Days',
			ORDER_AMOUNT: 'Total Purchase Order Amount',
			HEFTH_COMMISSION: 'Service Fees',
			VAT: 'VAT',
			TOTAL_AMOUNT_TO_PAID: 'Total Service Fees to be Paid',
			DIVIDEND_CANCEL_NOTE:
				'Upon confirming your cancellation, the system will not refund the action or its points and you may need to recharge your account to start a new action, by entering the OTP you agree on this',
			ABSTEEN_SHAREHOLDERS: 'Exclude Specific Shareholders',
			ABSTEENED_SHAREHOLDERS: 'Excluded Shareholders List',
			ENTER_ID_OR_NAME: 'Enter ID or Name',
			SHAREHOLDER_DIRECT_IBAN_TRANSFER: 'Shareholder Direct Bank Account Transfer',
			DIRECT_TRANSFER_TO_IBAN: 'Direct Bank Account Transfer Shareholders List',
			ENTER_IBAN: 'Enter IBAN',
			IBAN_UPDATED_SUCCESSFULLY: 'IBAN updated successfully',
			UPDATE_ERROR: 'An error occurred while updating IBAN.',
			IBAN_VALIDATION: 'Please enter a valid IBAN number.',
			ENTER_IBAN_FOR_DIRECT_TRANSFER: 'Enter all IBANs for direct transfer',
			ABSTEEN_SHAREHOLDERS_INFO: 'To exclude due to administrative, Financial or legal reasons',
			PROFIT: 'Dividend',
			BILL_NUMBER: 'Bill Number',
			TREASURY_SHARES_ACQUISITION_CREATED_SUCCESSFULLY: 'Treasury Shares Acquisition Request was Performed Successfully!',
			TREASURY_SHARES_ACQUISITION_UPDATED_SUCCESSFULLY: 'Treasury Shares Acquisition Request was Updated Successfully!',
			TREASURY_SHARES_ACQUISITION_NOT_CREATED: 'Treasury Shares Acquisition request not created',
			TREASURY_SHARES_ACQUISITION_NOT_UPDATED: 'Treasury Shares Acquisition request not updated',
			TOTAL_TREASURY_SHARES_TO_BE_ISSUED: 'Total number of Treasury shares to be issued',
			BOUGHT: 'Bought',
			REMAINING_DAYS: 'Remaining Days',
			SELLERS: 'Sellers',
			OWNED_SHARES: 'Owned Shares',
			SHAREHOLDERS_LIST: 'Shareholders List',
			TOTAL_NEW_COMMON_SHARES: 'Total New Common Shares',
			ISSUING_DATE: 'Issuing Date',
			ISSUANCE_PRICE: 'Issuance Price',
			SHARE: 'Share',
			ADD_NEW: 'Add New',
			CLEAR_ALL_BOARD: 'Clear All Board',
			ADD_OWNERS_REGISTRY: 'Add Owners Registry',
			ADD_OWNERS_REGISTRY_DESCRIPTION: 'Add all your data manually or Upload your file from your computer',
			DOWNLOAD_TEMPLATE: 'Download Template',
			CLEAR_ALL: 'Clear All',
			CLICK_OR_DRAG: 'Click to Upload or Drag & Drop',
			TOTAL_NO_OF_SHARES: 'Total no. of Shares',
			SHAREHOLDER_ALREADY_ADDED: 'Shareholder already added',
			SHARES_EXCEEDING_LIMIT: 'Shares exceeding limit: {{limit}}',
			DELETE_SHAREHOLDER_CONFIRMATION: 'Delete Shareholder Confirmation',
			PRIVATE_EQUITY_ISSUANCE_UPDATED_SUCCESSFULLY: 'Private Placement Request was Updated Successfully!',
			PRIVATE_EQUITY_ISSUANCE_CREATED_SUCCESSFULLY: 'Private Placement Request was Performed Successfully!',
			PRIVATE_EQUITY_ISSUANCE_NOT_UPDATED: 'Private Placement request not updated',
			PRIVATE_EQUITY_ISSUANCE_NOT_CREATED: 'Private Placement request not created',
			PRIVATE_EQUITY_ISSUANCE_NOTE:
				'You acknowledge that this issuance is already informed to the CMA and was accepted as per the Saudi laws of securities. and was agreed by the general shareholders’ ordinary assembly. ',
			STILL_HAVE_SHARES_TO_ISSUE: 'You still have {{remaining}} shares to issue',
			FILE_UPLOADED: 'File uploaded successfully',
			NEW_CAPITAL_DOCUMENT: 'New Capital Document',
			CURRENTLY_UPLOADED_DOCUMENT: 'Currently uploaded document',
			'1_DAY': '1 Day',
			'3_DAYS': '3 Days',
			'7_DAYS': '7 Days',
			'15_DAYS': '15 Days',
			'30_DAYS': '30 Days',
			CREATE_INVOICE: 'Generate Bill',
			AGREEMENT_TO_TERMS_TREASURY: 'I acknowledge and agree to the Terms and Conditions of Treasury Shares Acquisition Request.',
			TREASURY_SHARES_ACQUISITION_NOTE:
				"You acknowledge that upon completion of the purchase order, a list of sellers' amounts will be created, and the company is obligated to transfer money directly to their bank accounts.",
			TREASURY_CONFIRM: 'Confirm Treasury Request',
			TREASURY_CONFIRM_SUBTITLE: 'Please enter code to process your request',
			AGREEMENT_TO_TERMS_AUTHORIZED_CAPITALS: 'I acknowledge and agree to the Terms and Conditions of Authorized Capital Update.',
			AGREEMENT_TO_TERMS_PRIVATE_EQUITY: 'I acknowledge and agree to the Terms and Conditions of Private Placement Operation.',
			CANCEL_PROFIT_CAPITALIZATION: 'Cancel Profit Capitalization',
			CONFIRM_CANCEL_PROFIT_CAPITALIZATION: 'Are you sure you want to cancel this profit capitalization?',
			PROFIT_CAPITALIZATION_CANCELLED: 'Profit Capitalization cancelled successfully',
			CANCEL_TREASURY_SHARES_ACQUISITION: 'Cancel Treasury Shares Acquisition',
			CONFIRM_CANCEL_TREASURY_SHARES_ACQUISITION: 'Are you sure you want to cancel this treasury shares acquisition?',
			TREASURY_SHARES_ACQUISITION_CANCELLED: 'Treasury Shares Acquisition cancelled successfully',
			CANCEL_PRIVATE_EQUITY_ISSUANCE: 'Cancel Private Placement',
			CONFIRM_CANCEL_PRIVATE_EQUITY_ISSUANCE: 'Are you sure you want to cancel this private equity issuance?',
			PRIVATE_EQUITY_ISSUANCE_CANCELLED: 'Private Placement cancelled successfully',
			OWNED_SHARES_EXCEED_LIMIT: 'Owned shares exceeding limit: {{limit}} shares',
			COMMITTEES_STRUCTURE: 'Committees Structure',
			COMMITTEES_MEETINGS: 'Committees Meetings',
			BOARD_COMMITTEES: 'Board Committees',
			FORM_NEW_COMMITTEE: 'Form New Committee',
			COMMITTEES_DESC: 'Fill out these details to build your Company',
			NO_COMMITTEE_AVAILABLE: 'No committee available.',
			SPECIFIC_BOARD_MEMBERS: 'Specific Board Members',
			COMMITTEE_NAME_AR: 'Committee Name in Arabic',
			COMMITTEE_NAME_EN: 'Committee Name in English',
			COMMITTEE_DESCRIPTION: 'Committee Description',
			COMMITTEE_DESCRIPTION_AR: 'Committee Description in Arabic',
			COMMITTEE_DESCRIPTION_EN: 'Committee Description in English',
			COMMITTEE_MEMBERS: 'committee members',
			ADD_COMMITTEE_MEMBERS: 'Please add committee members',
			COMMITTEE_DETAILS: 'Committee Details',
			CREATE_COMMITTEE: 'Create Committee',
			NEW_COMMITTEE: 'New Committee',
			COMMITTEE_SETTINGS: 'Committee Settings',
			TOTAL_COMMITTEE_MEMBERS: 'Total Committee Members',
			COMMITTEE_TERM: 'Committee Term',
			MINIMUM_QUORUM_PERCENTAGE: 'Minimum Quorum Percentage',
			MAXIMUM_ABSENCE_BEFORE_NOTIFICATION: 'Maximum Absence Before Notification',
			MINIMUM_NOTIFICATION_DAYS: 'Minimum Notification Days',
			ALLOW_SECRETARY_UPDATE: 'Allow Secretary Update',
			ALLOW_EXTERNAL_GUESTS: 'Allow External Guests',
			COMMITTEE_CREATED_SUCCESSFULLY: 'Committee created successfully',
			COMMITTEE_DELETED_SUCCESSFULLY: 'Committee deleted successfully',
			COMMITTEE_DELETED_FAILED: 'An error occurred while deleting the committee.',
			COMMITTEE_APPOINTED_SUCCESSFULLY: 'Committee appointed successfully',
			COMMITTEE_TERMINATED_SUCCESSFULLY: 'Committee terminated successfully',
			APPOINT_COMMITTEE: 'Appoint Committee',
			TERMINATE_COMMITTEE: 'Terminate Committee',
			DELETE_COMMITTEE: 'Delete Committee',
			CONFIRM_DELETE_COMMITTEE: 'Are you sure you want to delete this committee?',
			COMMITTEE_DELETE_NOTE:
				'Committee deletion will be effective immediately, please be aware that after deleting the committee all its data will be lost and cannot be restored.',
			CONFIRM_TERMINATE_COMMITTEE: 'Are you sure you want to terminate this committee?',
			CONFIRM_APPOINT_COMMITTEE: 'Are you sure you want to appoint this committee?',
			ACTIVE_COMMITTEE: 'Active Committee',
			DRAFT_COMMITTEE: 'Draft Committee',
			INACTIVE_COMMITTEE: 'Inactive Committee',
			COMMITTEE_STATUS: 'Committee Status',
			SELECT_MEMBER_TYPE: 'Select Member Type',
			EXTERNAL: 'External',
			REGULAR: 'Regular',
			COMMITTEE_MEETINGS: 'Committee Meetings',
			MEETING_NUMBER: 'Meeting Number',
			MEETING_TIME: 'Meeting Time',
			MEETING_LOCATION: 'Meeting Location',
			MEETING_LINK: 'Meeting Link',
			ADD_GUEST: 'Add Guest',
			GUEST_NAME: 'Guest Name',
			GUEST_ROLE: 'Guest Role',
			COMMITTEE_DOCUMENTS: 'Committee Documents',
			NEW_COMMITTEE_DOCUMENT: 'New Committee Document',
			DOCUMENT_NAME: 'Document Name',
			DOCUMENT_NAME_AR: 'Document Name in Arabic',
			DOCUMENT_NAME_EN: 'Document Name in English',
			SELECT_DOCUMENT_TYPE: 'Select Document Type',
			REGULATION: 'Regulation',
			POLICY: 'Policy',
			REPORT: 'Report',
			OTHER: 'Other',
			DOCUMENT_FILE: 'Document File',
			UPLOAD_DOCUMENT: 'Upload Document',
			UPLOADED_AT: 'Uploaded At',
			APPOINTED_AT: 'Appointed At',
			TERMINATED_AT: 'Terminated At',
			MEMBERS_COUNT: 'Members Count',
			CURRENT_MEMBERS: 'Current Members',
			FILL_TO_CREATE_COMMITTEE: 'Fill out these details to create a committee',
			ATTACH_MEMBERS: 'Attach Members',
			ATTACH_MEMBERS_TO_COMMITTEE: 'Attach Members to Committee',
			IS_SECRETARY: 'Is Secretary?',
			SELECT_MEMBERS: 'Select Members',
			MEMBERS_ATTACHED_SUCCESSFULLY: 'Members attached successfully',
			ATTENDANCE_PERCENTAGE: 'Attendance Percentage',
			COMMITTEE_ATTENDANCE: 'Committee Attendance',
			MEETING_DECISIONS: 'Meeting Decisions',
			NEW_COMMITTEE_FORMATION: 'New Committee Formation',
			FILL_TO_APPOINT_COMMITTEE: 'Fill out these details to appoint Company’s Board of directors',
			COMMITTEE_GOVERNANCE: 'Committee Governance',
			COMMITTEE_GOVERNANCE_DESC: 'Please Choose Committee Governance.',
			TOTAL_COMMITTEE_MEMBERS_VALIDATION: 'The Committee must have at least 3 members and not exceed 15 members.',
			MAXIMUM_ABSENCE_BEFORE_NOTIF_VALIDATION_COMMITTEE: 'Maximum absence before notification must not exceed 50% of the committee meetings.',
			FETCH_COMMITTEE_DETAILS_ERROR: 'An error occurred while fetching committee details.',
			COMMITTEE_NAME: '{{name}} Committee',
			DRAFT: 'Draft',
			COMMITTEE_MEMBER_DELETE_NOTE:
				'Member deletion will be effective after saving all changes, please be aware that after saving all changes this member can not be in the committee unless you re-add him again.',
			COMMITTEE_APPOINTMENT_VERIFICATION_NOTE:
				'Appoint new committee  will be effective after you confirm, Please be aware: according to Saudi MOC Laws,new company committee appointment must be approved by the Assembly.',
			COMMITTEE_MEMBER_CREATED_SUCCESSFULLY: 'Committee member created successfully',
			COMMITTEE_MEMBER_UPDATED_SUCCESSFULLY: 'Committee member updated successfully',
			'BOARD-CHAIR': 'Board Chair',
			'VICE-CHAIRMAN': 'Vice Chairman',
			'BOARD-SECRETARY': 'Board Secretary',
			MEETING: 'Meeting',
			ACTUAL_PERCENTAGE: 'The displayed percentage has been rounded for better number presentation. The actual percentage is: {{value}}%',
			MEETING_PUBLISHED_SUCCESSFULLY: 'Meeting published successfully',
			EXPLANATION: 'Explanation',
			LOYALTY_PROGRAMS: 'Loyalty Programs',
			LOYALTY_PROGRAMS_DESC: 'Retain Your Talented Employees',
			LOYALTY_PROGRAMS_CREATE_DESC: 'Fill out these details to build your Company',
			UNLOCK_NOW: 'Unlock Now',
			FEATURE_LOCKED: 'Feature Locked',
			FEATURE_LOCKED_DESC1: 'Your Company Asas Contract does not support this feature.',
			FEATURE_LOCKED_DESC2: 'Please include this in your contract and request unlock.',
			EMPLOYEE_NAME: 'Employee Name',
			INCENTIVE_TYPE: 'Incentive Type',
			FREE_TREASURY_SHARES: 'Free Treasury Shares: {{num}}',
			AVAILABLE_TREASURY_SHARES: 'Available Treasury Shares: {{num}}',
			SUSPENDED_TREASURY_SHARES: 'Suspended Treasury Shares: {{num}}',
			NO_SHARES_AVAILABLE: 'No available treasury shares to create a loyalty program',
			LOYALTY_PROGRAM_CREATED: 'Loyalty Program {{type}} was Created Successfully!',
			GRANT: 'Grant',
			GRANT_DESC: 'Grant treasury shares to your team free of charge.',
			OPTION: 'Option',
			OPTION_DESC: 'Grant treasury shares to you team at discounted or specific price.',
			BENEFICIARY_NATIONAL_ID: 'Beneficiary National ID',
			FULL_NAME: 'Full Name',
			NUMBER_OF_SHARES: 'Number of Shares',
			SALARY_DEDUCTION_PAYMENT: 'Salary Deduction Payment',
			SALARY_DEDUCTION_PAYMENT_INFO: 'If not activated, the beneficiary will pay through the Tanaqul app.',
			COMPANY_DEDUCTION: 'Company will deduct the amount.',
			RESTRICTED_BY_DATE: 'Restricted by date',
			RESTRICTED_BY_DATE_DESC: 'Shares will be added in beneficiary account at this date.',
			PERIODIC: 'Periodic',
			PERIODIC_DESC: 'Grant based on interval schedule to specific date.',
			LOYALTY_ACKNOWLEDGE1: 'I Acknowledge an agree on the Terms and Conditions of Registry Transaction.',
			LOYALTY_ACKNOWLEDGE2: "By clicking, I acknowledge that this transaction can't be reversed.",
			LOYALTY_ACKNOWLEDGE3: 'By clicking, I acknowledge that the executive management of the company has the authority for this action.',
			CURRENT_EMPLOYMENT_CONDITION: 'Current Employment Condition',
			CURRENT_EMPLOYMENT_CONDITION_DESC: 'Employee will agree to maintain his position at Eligibility date',
			START_DATE: 'Start Date',
			INTERVAL_PERIOD: 'Interval Period',
			INTERVAL_AMOUNT: "Interval's Amount",
			SHARE_PER_INTERVAL: 'Share / Interval',
			NUMBER_OF_INTERVALS: 'Number of intervals',
			PLANNED: 'Planned',
			PROGRAM_TOTAL_SHARES: 'Program Total Shares',
			PROGRAM_TOTAL_VALUE: 'Program Total Value',
			CONFIRM_GRANT: 'Confirm Grant',
			CONFIRM_GRANT_DESC:
				'Please be aware that only some  of the programs is reversible. upon acceptance of beneficiary and any transfers is completed the amount of those shares will not be redeemable under any circumstances.',
			COMMITTEES_DOCUMENTS: 'Committees Documents',
			SELECT_COMMITTEE: 'Select a committee to schedule a meeting for it',
			NEW_COMMITTEE_MEETING: 'New Committee Meeting',
			NEW_NAME_COMMITTEE_MEETING: 'New {{name}} Committee Meeting',
			CHOOSE_MEETING_TIME: 'Choose meeting time',
			TERMINATE: 'Terminate',
			EXTEND: 'Extend',
			TERMINATE_CONFIRMATION: 'Terminate Confirmation',
			EXTEND_COMMITTEE: 'Extend Committee',
			ADDITIONAL_YEARS: 'Additional Years',
			MEETING_DURATION: 'Meeting Duration',
			PROGRAM_TYPE: 'Program Type',
			GRANT_SHARES: 'Grant Shares',
			OPTION_SHARES: 'Option Shares',
			LOYALTY_PROGRAM_PERIODIC: 'Periodic',
			PERIODIC_GRANT_SHARES: 'Periodic Grant Shares',
			PERIODIC_OPTION_SHARES: 'Periodic Option Shares',
			PROGRESS: 'Progress',
			BENEFICIARY_NAME: 'Beneficiary Name',
			PAYMENT_METHOD: 'Payment Method',
			PAYMENT: 'Payment',
			EMPLOYEE_PAYS_THROUGH_APP: 'Employee Pays Through App',
			EMPLOYEE_PAYS_THROUGH_APP_DESC: 'will use his investment account or card to pay',
			SALARY_DEDUCTION: 'Salary Deduction',
			SALARY_DEDUCTION_DESC: 'Company responsible of collecting the payment',
			PROGRAM_SHARES: 'Program Shares',
			SHARES_GRANTED: 'Shares Granted',
			SHARES_NOT_GRANTED: 'Shares not Granted',
			TOTAL_PAYMENT: 'Total Payment',
			ORDER: 'Order',
			GRANT_DATE: 'Grant Date',
			GRANTED: 'Granted',
			NOT_GRANTED: 'Not Granted',
			PENDING_PAYMENT: 'Pending Payment',
			DOWNLOAD_FILE: 'Download file',
			NUM_SHARES: '{{num}} Shares',
			CANCEL_DISTRIBUTION_CONFIRM: 'Are you sure you want to cancel this distribution?',
			DISTRIBUTE_CONFIRM: 'Are you sure you want to grant this distribution?',
			CONFIRM_GRANT_CANCELLATION: 'Confirm Grant Cancellation',
			CONFIRM_GRANT_CANCELLATION_DESC:
				'Please be aware that this grant is governed by a contract between your company and the beneficiary and canceling without legal reason can lead to legal implications so please use this action wisely.',
			CONFIRM_OPTION_GRANT: 'Confirm Option Grant',
			CONFIRM_OPTION_REFUSAL: 'Confirm Option Refusal',
			CONFIRM_OPTION_GRANT_APP_DESC:
				'Please be aware that this grant is governed by a contract between your company and the beneficiary and you confirm that you authorize Takharoj finance to collect the money from the employee and entering the code means the grant is final and irreversible.',
			CONFIRM_OPTION_GRANT_SALARY_DESC:
				'Please be aware that this grant is governed by a contract between your company and the beneficiary and you confirm that money was deducted from the employee salary and entering the code means the grant is final and irreversible.',
			BENEFICIARIES: 'Beneficiaries',
			TRANSFER_TYPE: 'Transfer Type',
			SELECT_COMMITTEE_DOCUMENT: 'Select a committee to add a document for it',
			MEMBER_PHONE_NUMBER: 'Member Mobile Number',
			ACCEPTANCE_DAYS: 'Acceptance Days',
			ELIGIBILITY_DATE_MIN: 'Eligibility date must be at least {{days}} days from today',
			ONE_MONTH: '1 Month',
			THREE_MONTHS: '3 Months',
			SIX_MONTHS: '6 Months',
			NINE_MONTHS: '9 Months',
			TWELVE_MONTHS: '12 Months',
			MEMBER_ALERT: 'Some information may be inaccurate until the member is registered through Nafath, Please verify the national ID',
			GRANTED_SHARES: 'Granted Shares',
			LOYALITY_START_DATE: 'Loyalty Program Start Date',
			'14_DAYS': '14 Days',
			'21_DAYS': '21 Days',
			OPTION_VIEW: 'View Option',
			GENERAL_SUSPEND_LOYALITY_MESSAGE: 'General suspend is active, loyalty programs creation not allowed',
			DISTRIBUTED_TOTAL_NOT_EQUAL_NUMBER_OF_SHARES: 'Distributed total does not equal number of shares',
			PAID_AMOUNT: 'Paid Amount',
			REMAINING_AMOUNT: 'Remaining Amount',
			LOYALTY_PROGRAM_ACTIVATION_NOTE:
				'Please be aware based on the Saudi Laws, Employee loyalty programs should be enrolled in company’s ASAS contract after the approval of company’s assembly.',
			COMMITTEE_MEMBER_DELETED_SUCCESSFULLY: 'Committee member deleted successfully',
			COMMITTEE_CHAIRMAN: 'Committee Chairman',
			COMMITTEE_VICE_CHAIRMAN: 'Committee Vice Chairman',
			FAILED: 'Failed',
			SEARCH_IN_ATTENDANCE: 'Search in Attendance',
			SUSPEND_REASON_TOOLTIP: 'The suspension reason displayed to shareholders',
			UPLOAD_DOCUMENTS_TOOLTIP: 'The documents displayed to shareholders',
		},
		COMPANY_INFORMATION: {
			OVERVIEW: 'Overview',
			SHAREHOLDERS_LIST: 'Shareholders List',
			MAJOR_SHAREHOLDERS: 'Major Shareholders',
			TRANSACTIONS_LOGS: 'Transactions Logs',
			PAYMENTS: 'Billing',
			DATA_ROOM: 'Data Room',
			FINANCIAL_STATEMENT: 'Financial Statement',
			TOTAL_COMMON_SHARES: 'Total Common Shares',
			COMPANY_CAPITAL_IN_SAR: 'Company Capital',
			LATEST_TRANSACTIONS: "Latest transactions on the company's account",
			REGISTRY_TRANSACTIONS: 'Registry Transactions',
			COUNT_OF_FREE_COMMON_SHARES: 'Count of Free Common Shares',
			COUNT_OF_FREE_PREFERRED_SHARES: 'Count of Free Preferred Shares',
			GRANTED_REQUESTS: 'Pending Grant Requests',
			COUNT_OF_SUSPENDED_COMMON_SHARES: 'Count of Suspended Common Shares',
			COUNT_OF_SUSPENDED_PREFERRED_SHARES: 'Count of Suspended Preferred Shares',
			GRANTED_TREASURY_SHARES: 'Granted Treasury Shares',
			COUNT_OF_MORTGAGED_COMMON_SHARES: 'Count of Mortgaged Common Shares',
			COUNT_OF_MORTGAGED_PREFERRED_SHARES: 'Count of Mortgaged Preferred Shares',
			RESERVED_TREASURY_SHARES: 'Reserved Treasury Shares',
			VAT_REGISTRATION_NUMBER: 'VAT Registration Number',
			PAYMENT_TYPE: 'payment Type',
			PLAN: 'Plan',
			INVOICE_NUMBER: 'Invoice Number',
			WALLET_CHARGE: 'Wallet Charge',
			POINT_WALLET_CHARGE: 'Point Wallet Charge',
			BUY_PLAN: 'Buy Plan',
			CAP_TABLE: 'Cap Table',
			NAME_OF_SHAREHOLDER: 'Name of Shareholder',
			TOTAL_VALUE_OF_HOLDINGS: 'Total Value of Holdings',
			EQUITY: 'Equity',
			TOTAL_SHARES_HOLDINGS: 'Total Shares Holdings',
			PERCENTAGE_OF_HOLDINGS: '% of Holdings',
			OTHERS: 'Others Shareholders',
			NO_PREFERRED_SHARES: 'No Preferred Shares',
			DOCUMENTS: 'Documents',
			BRAND_IDENTITY: 'Brand Identity',
			UPDATE_BRAND_IDENTITY: 'Update Brand Identity',
			COMPANY_AR_NAME: 'Company Name in Arabic',
			COMPANY_EN_NAME: 'Company Name in English',
			DESCRIPTION_IN_ARABIC: 'Description in Arabic',
			DESCRIPTION_IN_ENGLISH: 'Description in English',
			COMPANY_LOGO: 'Company Logo',
			SEND_REQUEST_FOR_APPROVAL: 'Send Request for Approval',
			UNDER_REVIEW: 'Under Review',
			UNDER_REVIEW_DESC: 'Your business identity update request has been successfully completed, your request is under review',
			SUBMIT_IDENTITY_SUCCESS: 'Brand identity submitted for review successfully',
			NO_PREFERRED_SHARES_AVAILABLE: 'No Preferred Shares Available',
			COMPANY_MANAGER_AR_NAME: 'Company Manager Name in Arabic',
			COMPANY_MANAGER_EN_NAME: 'Company Manager Name in English',
			MAJOR_SHAREHOLDERS_DESC: "Those who own 5% or more of the company's shares",
			COUNT: 'Count',
			SETTINGS: 'Settings',
			TRANSFER_SETTINGS: 'Transfer Settings',
			CUSTOMIZE_TRANSFER_RULES: 'To Customize Transfer Rules',
			TRANSFER_LIMITATION: 'Transfer Limitations',
			MINIMUM_SHARES_PER_TRANSFER: 'Minimum Shares per Transfer',
			MAXIMUM_SHARES_PER_TRANSFER: 'Maximum Shares per Transfer',
			MINIMUM_TRANSFER_SELLING_PRICE: 'Minimum Transfer Selling Price',
			TRANSFER_ACTIVATIONS: 'Transfer Activations',
			HALT_TRANSFER: 'Halt Transfer',
			COMPANY_APPROVAL_ON_TRANSFER_REQUESTS: 'Company Approval on Transfer Requests',
			VIEW_LAST_PRICE_CHART: 'View Last Price Chart',
			PER_SHARE: 'Per share',
			TRANSFER_SETTINGS_UPDATED_SUCCESSFULLY: 'Transfer settings updated successfully',
			MINIMUM_SHARES_PER_TRANSFER_MIN: 'The minimum shares per transfer field must be at least 1',
			MAXIMUM_SHARES_PER_TRANSFER_MIN: 'The maximum shares per transfer field must be at least 1',
			MINIMUM_TRANSFER_SELLING_PRICE_MIN: 'The minimum transfer selling price field must be at least 0.01',
			APPROVALS: 'Approvals',
			LIMITATION_TRANSFER_SETTINGS_UPDATED_SUCCESSFULLY: 'Transfer Limitation settings updated successfully',
			ACTIVATION_TRANSFER_SETTINGS_UPDATED_SUCCESSFULLY: 'Transfer Activation settings updated successfully',
			EMPTY_INFORMATION_TOOLTIP: 'Leave this field empty if no limitation should be applied',
			SETTINGS_CONFIRM_TITLE: 'Update Transfer Settings',
			TRANSFER_RESTRICTION_NOTE:
				"Important Note: Adding restrictions on share trading must be approved by the General Assembly and included in the company's ASSAS contract. Otherwise, it constitutes a clear violation of the Saudi Companies Law and the regulations of the Capital Market Authority.",
			HALT_TRANSFER_NOTE:
				"Important Note: Suspending trading does not cancel existing transactions. Cancellation of existing transactions is done exclusively by suspending the company's shares.",
			TOTAL_AMOUNT: 'Total Amount',
			TRANSFER_APPROVALS: 'Transfer Approvals',
			APPROVE: 'Approve',
			APPROVE_CONFIRMATION: 'Are you sure you want to approve this transfer request?',
			REJECT: 'Reject',
			REJECT_CONFIRMATION: 'Are you sure you want to reject this transfer request?',
			TRANSFER_APPROVED_SUCCESSFULLY: 'Transfer approved successfully',
			TRANSFER_REJECTED_SUCCESSFULLY: 'Transfer rejected successfully',
			REJECTION_NOTE: 'Rejection Note',
			VIEW_REJECTION_NOTE: 'View Rejection Note',
			COMPANY_APPROVAL_STATUS: 'Company Approval Status',
			CONTACT_PHONE_NUMBER: 'Contact Phone Number',
			CONTACT_EMAIL: 'Contact Email',
			GENERAL_SUSPEND_MESSAGE: 'General suspend is active change settings not allowed',
		},
		USERS_MANAGEMENT: {
			ADD_NEW_USER: 'Add New User',
			UPDATE_USER: 'Update User',
			TO_MANAGE_YOUR_SYSTEM: 'To manage your system users',
			ADD_USER: 'Add User',
			USER_NAME: 'User Name',
			ACCESS_ROLE: 'Access Role',
			FILL_DETAILS_TO_ADD_USER: 'Fill out these details to add a new user',
			SELECT_ACCESS_AUTHORITY: 'Select access authority',
			VIEW_COMPANY_INFORMATION: 'View Company Information',
			COMPANY_DOCUMENT_UPDATE: 'Company Document Update',
			USERS_MANAGEMENT: 'Users Management',
			REGISTRY_TRANSACTIONS: 'Registry Transactions',
			HEIR_TRANSACTION: 'Heir Transaction',
			SHAREHOLDER_INFORMATION: 'Shareholder Information',
			NOTICE: 'Notice',
			SUSPEND_ACTION: 'Suspend Action',
			CHARGE_POINTS: 'Charge Points',
			ANNOUNCEMENT_ACTION: 'Announcement Action',
			CUSTOMER_SERVICE: 'Customer Service',
			UPDATE_COMPANY_INFORMATION: 'Update Company Information',
			FINANCIAL_STATEMENT: 'Financial Statement',
			EDIT_USER: 'Edit User',
			SUSPEND: 'Suspend',
			SUSPEND_USER: 'Suspend User',
			UNSUSPEND_USER: 'Unsuspend User',
			SUSPEND_USER_DESC: 'Are you sure you want to suspend this user?',
			DELETE_USER: 'Delete User',
			DELETE_USER_DESC: 'Are you sure you want to delete this user?',
			RESET_PASSWORD: 'Reset Password',
			RESET_USER_PASSWORD: 'Reset User Password',
			COMPANY: 'Company',
			COMPANY_INFORMATION: 'Company Information',
			MORTGAGE_REQUEST: 'Mortgage Request',
			MORTGAGE_RELEASE: 'Mortgage Release',
			SYSTEM_USERS: 'System Users',
			SELECT_AR_LEAST_ONE: 'Select at least one access role',
			USER_CREATED_SUCCESSFULLY: 'User created successfully',
			USER_UPDATED_SUCCESSFULLY: 'User data updated successfully',
			USER_NOT_FOUND: 'User not found',
			USER_SUSPENDED: 'User suspended successfully',
			USER_UNSUSPENDED: 'User unsuspended successfully',
			UNSUSPEND: 'Unsuspend',
			USER_DELETED: 'User deleted successfully',
			USER_PASSWORD_RESET: 'User password reset successfully',
		},
		MORTGAGE: {
			CREATE_NEW_REQUEST: 'Create New Request',
			FILL_DATA: 'Fill out these details to Serving your client.',
			COMMERCIAL_REGISTRATION_NUMBER: 'Commercial Registration Number',
			iNVESTOR_NOT_FOUND: 'Investor Not Found',
			REGISTER_NUMBER_NOT_FOUND: 'Register Number Not Found',
			BOARD: 'Board',
			MEMBER: 'Member',
			NATIONALITY: 'Nationality',
			COMPANY_DOCUMENTS: 'Company Documents',
			TOTAL_SHARES_HOLD: 'Total Shares Hold',
			ON: 'On',
			HOLD_TO: 'Hold To',
			HOLD_SHARES: 'Hold Shares',
			TOTAL_SHARES_NUM: 'Total number of Shares',
			MATURITY_DATE: 'Maturity Date',
			MORTGAGE_MATURITY_DATE: 'Mortgage Maturity Date',
			AGREEMENT_1: 'I acknowledge and agree to the Terms and Conditions of Registry Transaction.',
			AGREEMENT_2: "By clicking, I acknowledge that this transaction can't be reversed.",
			REQUEST_NUMBER: 'Request Number',
			REQUEST_DATE: 'Request Date',
			CLIENT_ID: 'Client ID',
			HISTORY: 'History',
			REQUEST: 'Request',
			RELEASE_MORTGAGE: 'Release Mortgage',
			ACTIVITY_LOG: 'Activity Log',
		},
	},
};

export default en;
